<template>
  <div
    id="checkout-content--right"
    :class="!isSizeWindow ? 'embed-checkout-right-wrapper' : ''"
  >
    <!-- PRODUCT GUARANTEE-->
    <template v-if="displayDiv(posName, 'guaranteeSeal')">
      <div
        v-if="
          data.showSeals &&
          ((data.themeType == 'Classic' && data.templateType == 'RightSidebar' && (screenMoreThan991px || isSizeWindow)) ||
            (data.themeType == 'Classic' && data.templateType == 'LeftSidebar' && !isSizeWindow))
        "
        class="checkout-content--right__guarantee"
      >
        <!-- <Seal :data='data' :isSizeWindow='isSizeWindow' :direction='column' /> -->
        <Seal :data="data" :isSizeWindow="isSizeWindow" />
      </div>
    </template>

    <div
      ref="rightContainer"
      class="embed-checkout-right__container"
      :class="embed && popup ? 'embed-rightGroup' : ''"
      :data-name="posName"
    >
      <!-- PRODUCT VARIANT-->
      <template v-if="displayDiv(posName, 'productDetails')">
        <div
          v-if="data.type != 'simple'"
          class="checkout-content--right__feature checkout-content--right__product-variants"
        >
          <div 
            v-if="data.marketPlaceStyle && isSizeWindow"
            class="product-variants__container--1"
          >
              <div class="d-flex justify-between">
                <label class="text--subtitle">{{ $t('common.productOptions') }}</label>
              </div>
              <div
                class="product-variants__select-mobile"
                style="margin-top: 8px;"
                :data-active="modalVariantOpen"
                @click="openChooseVariantModal()"
              >
                <div class="product-variants__select-mobile__content">
                  Pilih varian
                </div>
                <div class="product-variants__select-mobile__arrow">
                  <svg width="24px" height="24px" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20">
                    <path stroke="#6C7E95" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.3" d="M6 8l4 4 4-4"/>
                  </svg>
                </div>
              </div>

              <div v-if="isProductVariantSelected" style="margin-top: 8px;">
                <SelectedVariantChips :data="data" :cartSummary="cartSummary" />
              </div>
            </div>

          <div v-else class="product-variants__container--2">
            <template v-if="data.multiplyVariations && !data.cartOrder">
              <div class="various-options">               
                <div v-if="data.attributes && data.attributes.length">
                  <label class="text--subtitle mb-10">{{
                    data.titleVariations.replace(":", "")
                  }}</label>
                </div>

                <div class="options-group">
                  <div 
                    :key="'v' + i" 
                    v-for="(attr, i) in data.variablePrices.filter(x=>!x.delete)" 
                    class="variant-option-qty"
                  >
                    <div 
                      class="variant-option-qty__content" 
                      :class="isShowVariantImage?'variant-option-qty__content--show-thumbnail':''"
                    >
                      <div 
                        v-if="isShowVariantImage" 
                        class="variant-option-qty__content--show-thumbnail__thumbnail">
                        <img
                          :src="getImageSrc(attr)"
                          alt=""
                        />
                      </div>
                      <span class="variant-option-qty__content__label" :class="{'overflow-wrap--anywhere':isHasOneWordLongText(attr.name)}">
                        {{ attr.name }}
                      </span>
                    </div>
                    <div>
                      <div class="variant-option-qty__action">
                        <button
                          class="variant-option-qty__action__decrease"
                          @click="decrement(i, 'multiVariant')"
                        >
                          <img src="@/assets/icons/ic-action-decrease.svg" alt="-"/>
                        </button>
                        <!-- <vs-input
                          min="0"
                          v-model="attr.qty"
                          readonly
                        /> -->
                        <div class="variant-option-qty__action__number">{{ attr.qty }}</div>
                        <button
                          class="variant-option-qty__action__increase"
                          @click="increment(i, 'multiVariant')"
                        >
                          <img src="@/assets/icons/ic-action-increase.svg" alt="+"/>
                        </button>
                      </div>
                      <div v-if="attr && attr['zeroQTY']" class="invalid-feedback mt-0 text-right" style="white-space: nowrap;">
                        {{ attr['zeroQTY'] }}
                      </div>
                    </div>
                  </div>      
                </div>       

                <div ref="zeroQTY" class="invalid-feedback" style="scroll-margin: 65vh;"
                  :style="{ height: errors['zeroQTY'] ? 'auto' : '0px !important', marginTop: errors['zeroQTY'] ? '15px' : '0px' }">
                  {{ errors['zeroQTY'] }}
                </div>
              </div>
            </template>

            <template v-else>
              <template
                v-if="
                  data.attributes &&
                  data.attributes.length
                  // data.variationSelectType !== 'Radio'
                "
              >
                <h2 class="text--subtitle">
                  {{ data.titleVariations.replace(":", "") }}
                </h2>
              </template>  
                      
              <template v-for="(attr, i) in data.attributes">
              <div
                :key="'h' + i"
                class="product-variants__type"
                v-if="isShowFieldsProductAttributes(i, data.attributes)"
              >
                <label class="text--label-field">{{ attr.name }}</label>
                <no-ssr> 
                <div
                  v-if="data.variationSelectType == 'Radio' && payload.variablePrices[attr.name + i.toString()]"
                  class="product-variants__type__item--radio"
                >
                    <div
                      :key="'j' + j"
                      @click="
                        () =>
                          (payload.variablePrices[attr.name + i.toString()].name =
                            val)
                      "
                      class="product-variants__type__item--radio__option"
                      v-for="(val, j) in filteredProductVariant(attr.value, attr.name)"
                    >
                    
                      <vs-radio
                        v-model="
                          payload.variablePrices[attr.name + i.toString()].name
                        "
                        :val="val"
                        :disabled=checkOption(attr.name,val) 
                      >
                        <div>{{ val }}</div>
                      </vs-radio>
                  
                    </div>                 
                </div>
            
                <div
                  v-else-if="data.variationSelectType == 'Dropdown'"
                  class=""
                  style="min-width: 0;"
                >             
                    <Dropdown
                      class="w-100"
                      v-if="payload.variablePrices[attr.name + i.toString()]"
                      v-model="payload.variablePrices[attr.name + i.toString()].name"
                      :placeholder="'Pilih varian'"
                      :options="filteredProductVariant(attr.value, attr.name).map(value => ({ label: value, value }))"
                    />
                </div>

                <div v-else class="product-variants__type__item--modern">

                    <template v-for="(attrval, j) in filteredProductVariant(attr.value, attr.name)">
                      <selected-green-switch
                        v-if="payload.variablePrices[attr.name + i.toString()]"
                        :key="j"
                        v-model="payload.variablePrices[attr.name + i.toString()].name"
                        :filterAttributes="filterAttributes"
                        :options="[
                          {
                            id: attrval,
                            text: attrval,
                            imgSrc: undefined,  
                            disabled:checkOption(attr.name,attrval),
                            hideUnavailableVariant: data.hideUnavailableVariant
                          },
                        ]"
                        full="99"                      
                      >
                      </selected-green-switch>
                    </template>             
                </div>
              </no-ssr>
              </div>
              </template>

              <!-- Quantity in preview -->
              <template v-if="data.addQuantity && isAllVariantsSelectedValid()">
                <div class="buyButton rightCom">
                  <div class="singleVariant-qty">
                    <label class="text--label-field">{{ $t('common.quantity') }}</label>
                    <div
                      class="col-5 flex increDecre-btn-wrap"
                      style="max-width: 125px; border-radius: 8px"
                    >
                      <div
                        class="minus-btn pointer"
                        @click="decrement(0, 'singleVariant')"
                      >
                        <div class="bg-pm-btn relative">
                          <svg width="20" height="20" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M4.1665 10.488H15.8332" stroke="#6C7E95" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                          </svg>
                        </div>
                      </div>
                      <div
                        class="vs-form-control qty-input no-bg p-0 w-100 flex justify-center items-center"
                      >
                        {{ quantity }}
                        <!-- <vs-input min="0" disabled v-model="quantity" class="vs-form-control qty-input no-bg  p-0" /> -->
                      </div>
                      <div
                        class="plus-btn pointer"
                        @click="increment(0, 'singleVariant')"
                      >
                        <div class="bg-pm-btn relative">
                          <svg width="20" height="20" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M10 5.48804L10 15.488M15 10.488L5 10.488" stroke="#6C7E95" stroke-width="1.5" stroke-linecap="round"/>
                          </svg>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-if="errors && errors['zeroQTY']" class="invalid-feedback mt-0">
                    {{ errors['zeroQTY'] }}
                  </div>
                </div>
              </template>
            </template>

            <!-- Add to cart -->
            <template
              v-if="data.multiplyVariations && data.cartOrder && !((data.variablePrices.length>0 && !isVariableItemSelected))"
              class="embed-checkout-right-cart row buyButton rightCom"
            >
              <div
                @click="addToCart"
                class="buy-button flex justify-center items-center w-100 text-white text-center pointer"
                :class="(data.variablePrices.length>0 && !isVariableItemSelected) ? 'buy-button__default--disabled' :''"
                style="border-radius: 8px"
                :style="
                  'background-color: ' +
                  data.buyButtonStyle +
                  (loadingPrice ? '; opacity: 0.5;' : '')
                "
                 :disabled="(data.variablePrices.length>0 && !isVariableItemSelected)"  
                :data-size="data.buyButtonFontSize || 'Medium'"
              >
                <span
                  :class="{
                    'bold-buy-btn': data.boldBuyButtonText,
                    'small-buy-btn': data.buyButtonFontSize == 'Small',
                    'medium-buy-btn': data.buyButtonFontSize == 'Medium',
                    'large-buy-btn': data.buyButtonFontSize == 'Large',
                    'extra-large-buy-btn':
                      data.buyButtonFontSize == 'Extra-Large',
                  }"
                >
                  {{ $t('common.addToCart') }}
                </span>
              </div>
            </template>
          </div>
        </div>
      </template>

      <template v-if="data.formMode=='Show All'">
        <!-- RECIPIENT -->
        <div
          v-if="displayDiv(posName, 'requestedFields')"
          class="checkout-content--right__feature checkout-content--right__recipient"
        >
          <h2 class="text--subtitle">{{ data.titleForm }}</h2>
          <div class="recipient__form-container">
            <template
              v-for="(row, index) in data.requestedFields"
            >
              <template v-if="row.active">
                <div
                  v-if="showFields(index)"
                  :key="row.label+index"
                  class="recipient__form__field focus-active-field position-relative m-0"
                  :ref="row.field"
                  style="scroll-margin: 100px;"
                >
                  <div
                    v-if="row.field == 'address' && row.key == 'ENTER_CITY_NAME'"
                    class="address-fields"
                    :class="{
                      'is-invalid': errors[row.field],
                      'adjust-input-field': data.isLabel == 'showLabel',
                    }"
                  >
                    <AddressFill
                      :className="{
                        'is-invalid': errors[row.field],
                        'vs-form-control': true,
                      }"
                      @onChange="changeAddress"
                      :placeholder="row.placeholder"
                      :dontIncludeSubdistrict="payload.dontIncludeSubdistrict && !data.hasSubDistrict"
                      :dontIncludeZipcode="payload.dontIncludeZipcode && !data.hasSubDistrict"
                      :fieldName="row.key"
                      :fieldLabel="row.label"
                      :hasError="errors[row.field]"
                      :showLabel="data.isLabel == 'showLabel'"
                      :rules="getValidationRules(row)"
                      :addressVal="payload.address"
                      :shippingData="{'enableExcludeShipping':data.enableExcludeShipping,'excludeShipping':data.excludeShipping,'excludeShippingLocation':data.excludeShippingLocation}"
                    />

                    <!-- <div style="margin-top: 10px" class="village-checkbox">
                      <vs-checkbox v-if="row.label == 'Kota / Kecamatan'" v-model="payload.dontIncludeSubdistrict">Tanpa
                        Kelurahan</vs-checkbox>
                    </div> -->
                  </div>

                  <div
                    v-else-if="
                      row.field == 'address' && row.key == 'PROVINCE_NAME'
                    "
                    class="subAddress-fields"
                    :class="{ 'is-invalid': errors[row.field] }"
                  >
                    <ProvinceAddress
                      :className="{
                        'is-invalid': errors[row.field],
                        'vs-form-control': true,
                      }"
                      @onChange="(val) => changeAddresses(val, 'province')"
                      :value="selectedProvince"
                      :requires-city="isAddressFieldRequired('CITY_NAME')"
                      :has-city-field="isAddressFieldActive('CITY_NAME')"
                      :placeholder="row.placeholder"
                      :fieldName="row.key"
                      :fieldLabel="row.label"
                      :hasError="errors[row.field]"
                      :showLabel="data.isLabel == 'showLabel'"
                      :rules="getValidationRules(row)"
                      :isLabel="data.isLabel"
                      :formMode="data.formMode"
                      :shippingData="{'enableExcludeShipping':data.enableExcludeShipping,'excludeShipping':data.excludeShipping,'excludeShippingLocation':data.excludeShippingLocation}"
                    />
                  </div>

                  <div
                    v-else-if="
                      row.field == 'address' && row.key == 'CITY_NAME'
                    "
                    class="subAddress-fields"
                    :class="{ 'is-invalid': errors[row.field] }"
                  >
                    <CityAddress
                      :className="{
                        'is-invalid': errors[row.field],
                        'vs-form-control': true,
                      }"
                      @onChange="(val) => changeAddresses(val, 'city')"
                      :value="selectedCity"
                      :province="selectedProvince"
                      :requires-district="isAddressFieldRequired('DISTRICT_NAME')"
                      :has-district-field="isAddressFieldActive('DISTRICT_NAME')"
                      :placeholder="row.placeholder"
                      :fieldName="row.key"
                      :fieldLabel="row.label"
                      :hasError="errors[row.field]"
                      :showLabel="data.isLabel == 'showLabel'"
                      :rules="getValidationRules(row)"
                      :isLabel="data.isLabel"
                      :formMode="data.formMode"
                      :shippingData="{'enableExcludeShipping':data.enableExcludeShipping,'excludeShipping':data.excludeShipping,'excludeShippingLocation':data.excludeShippingLocation}"
                    />
                  </div>

                  <div
                    v-else-if="
                      row.field == 'address' && row.key == 'DISTRICT_NAME'
                    "
                    class="subAddress-fields"
                    :class="{ 'is-invalid': errors[row.field] }"
                  >
                    <DistrictAddress
                      :className="{
                        'is-invalid': errors[row.field],
                        'vs-form-control': true,
                      }"
                      @onChange="(val) => changeAddresses(val, 'district')"
                      :value="selectedDistrict"
                      :province="selectedProvince"
                      :city="selectedCity"
                      :requires-subdistrict="isAddressFieldRequired('SUBDISTRICT_NAME')"
                      :has-subdistrict-field="isAddressFieldActive('SUBDISTRICT_NAME')"
                      :placeholder="row.placeholder"
                      :fieldName="row.key"
                      :fieldLabel="row.label"
                      :hasError="errors[row.field]"
                      :showLabel="data.isLabel == 'showLabel'"
                      :rules="getValidationRules(row)"
                      :isLabel="data.isLabel"
                      :formMode="data.formMode"
                      :shippingData="{'enableExcludeShipping':data.enableExcludeShipping,'excludeShipping':data.excludeShipping,'excludeShippingLocation':data.excludeShippingLocation}"
                    />
                  </div>

                  <div
                    v-else-if="
                      row.field == 'address' && row.key == 'SUBDISTRICT_NAME'
                    "
                    class="subAddress-fields"
                    :class="{ 'is-invalid': errors[row.field] }"
                  >
                    <SubDistrictAddress
                      :className="{
                        'is-invalid': errors[row.field],
                        'vs-form-control': true,
                      }"
                      @onChange="(val) => changeAddresses(val, 'subdistrict')"
                      :value="selectedSubDistrict"
                      :province="selectedProvince"
                      :city="selectedCity"
                      :district="selectedDistrict"
                      :placeholder="row.placeholder"
                      :fieldName="row.key"
                      :fieldLabel="row.label"
                      :hasError="errors[row.field]"
                      :showLabel="data.isLabel == 'showLabel'"
                      :rules="getValidationRules(row)"
                      :isLabel="data.isLabel"
                      :formMode="data.formMode"
                      :shippingData="{'enableExcludeShipping':data.enableExcludeShipping,'excludeShipping':data.excludeShipping,'excludeShippingLocation':data.excludeShippingLocation}"
                    />
                  </div>

                  <div
                    v-else-if="
                      row.field == 'address' && row.key != 'ENTER_CITY_NAME'
                    "
                    class="subAddress-fields"
                    :class="{ 'is-invalid': errors[row.field] }"
                  >
                    <SubAddress
                      :className="{
                        'is-invalid': errors[row.field],
                        'vs-form-control': true,
                      }"
                      @onChange="changeAddress"
                      :placeholder="row.placeholder"
                      :dontIncludeSubdistrict="payload.dontIncludeSubdistrict"
                      :dontIncludeZipcode="payload.dontIncludeZipcode"
                      :fieldName="row.key"
                      :fieldLabel="row.label"
                      :hasError="errors[row.field]"
                      :showLabel="data.isLabel == 'showLabel'"
                      :rules="getValidationRules(row)"
                      :isLabel="data.isLabel"
                      :addressVal="payload.address"
                      :formMode="data.formMode"
                      :shippingData="{'enableExcludeShipping':data.enableExcludeShipping,'excludeShipping':data.excludeShipping,'excludeShippingLocation':data.excludeShippingLocation}"
                    />
                  </div>

                  <template v-else-if="row.isCustom">
                    <template v-if="row.fieldType == 'input'">
                      <Input
                        v-if="row.inputType == 'number'"
                        v-model="row.value"
                        type="number"
                        :placeholder="row.placeholder"
                        :label="data.isLabel == 'showLabel' ? row.label : undefined"
                        :name="row.label"
                        :rules="getValidationRules(row)"
                        :required="row.required == 'yes'"
                      />
                      <template  v-else-if="row.inputType == 'date'">
                        <InputDate
                          v-model="row.value"
                          :placeholder="row.placeholder"
                          :label="data.isLabel == 'showLabel' ? row.label : undefined"
                          :name="row.label"
                          :rules="getValidationRules(row)"
                          :required="row.required == 'yes'"
                        />
                      </template>
                      <div v-else-if="row.inputType == 'file'">
                        <InputFile
                          v-model="row.value"
                          :placeholder="row.placeholder"
                          :label="data.isLabel == 'showLabel' ? row.label : undefined"
                          :name="row.label"
                          :rules="getValidationRules(row)"
                          :required="row.required == 'yes'"
                          :overrideError="!row.value && Boolean(errors[row.field])"
                        />
                      </div>

                      <Input
                        v-else
                        v-model="row.value"
                        type="text"
                        :placeholder="row.placeholder"
                        :label="data.isLabel == 'showLabel' ? row.label : undefined"
                        :name="row.label"
                        :rules="getValidationRules(row)"
                        :required="row.required == 'yes'"
                      />
                    </template>

                    <div
                      v-else-if="row.fieldType == 'textarea'"
                      class="vs-form-control"
                    >
                      <Textarea
                        :placeholder="row.placeholder"
                        :rules="getValidationRules(row)"
                        :label="data.isLabel == 'showLabel' ? row.label : undefined"
                        :name="row.label"
                        v-model="row.value"
                        rows="3"
                        :required="row.required == 'yes'"
                      ></Textarea>
                    </div>

                    <div v-else :class="{ 'is-invalid': errors[row.field] }">
                      <Dropdown
                        v-model="row.value"
                        :placeholder="row.placeholder"
                        :rules="getValidationRules(row)"
                        :options="row.options.map(v => ({ value: v.name, label: v.name }))"
                        :label="data.isLabel == 'showLabel' ? row.label : undefined"
                        :name="row.label"
                        :use-bottom-sheet="$device ? $device.isMobile : false"
                        :bottomSheetTitle="row.label"
                        :required="row.required == 'yes'"
                      />
                    </div>
                  </template>

                  <Input
                    v-else-if="row.field == 'quantity'"
                    min="1"
                    max="100"
                    v-model="row.value"
                    type="number"
                    :placeholder="row.placeholder"
                    :label="data.isLabel == 'showLabel' ? row.label : undefined"
                    :name="row.label"
                    :rules="getValidationRules(row)"
                    :required="row.required == 'yes'"
                  />

                  <Input
                    v-else-if="row.field == 'phone'"
                    v-model="row.value"
                    :type="isMobile ? 'tel' : 'text'"
                    inputmode="numeric"
                    :placeholder="row.placeholder"
                    :label="data.isLabel == 'showLabel' ? row.label : undefined"
                    :name="row.label"
                    pattern="[0-9]*"
                    v-on:blur="() => formatPhone()"
                    :rules="getValidationRules(row)"
                    :required="row.required == 'yes'"
                  />

                  <template v-else-if="row.field == 'addressText'">
                    <Textarea
                      v-if="row.fieldType == 'textArea'"
                      :placeholder="row.placeholder"
                      :rules="getValidationRules(row)"
                      :label="data.isLabel == 'showLabel' ? row.label : undefined"
                      :name="row.label"
                      v-model="row.value"
                      rows="5"
                      :required="row.required == 'yes'"
                    ></Textarea>
                    <Input
                      v-else
                      v-model="row.value"
                      type="text"
                      :placeholder="row.placeholder"
                      :label="data.isLabel == 'showLabel' ? row.label : undefined"
                      :name="row.label"
                      :rules="getValidationRules(row)"
                      :required="row.required == 'yes'"
                    />
                  </template> 

                  <Input
                    v-else
                    v-model="row.value"
                    type="text"
                    :placeholder="row.placeholder"
                    :label="data.isLabel == 'showLabel' ? row.label : undefined"
                    :name="row.label"
                    :rules="getValidationRules(row)"
                    :required="row.required == 'yes'"
                  />

                  <div v-if="errors[row.field] && row.field == 'address'" class="invalid-feedback mt-5px">
                    {{ payload[row.field] && !payload[row.field][row.key.replace('_NAME', '')] ? errors[row.field] : !payload[row.field] ? errors[row.field] : '' }}
                  </div>
                  <div v-else-if="errors[row.field] && row.inputType !== 'file' || (row.inputType === 'file' && errors[row.field] && !row.value)" class="invalid-feedback mt-5px">
                    {{ errors[row.field] }}
                  </div>
                </div>
              </template>
            </template>
          </div>
        </div>
      </template>
      <template v-else>
        <no-ssr>
        <!-- RECIPIENT -->
          <div
            v-if="displayDiv(posName, 'requestedFields')"
            class="checkout-content--right__feature checkout-content--right__recipient"
          >
            <h2 class="text--subtitle">{{ data.titleForm }}</h2>
            <div class="recipient__form-container">
              <template
                v-for="(row, index) in data.requestedFields"
              >
                <template v-if="row.active">
                  <div
                    v-if="showFields(index)"
                    :key="row.label+index"
                    class="recipient__form__field focus-active-field position-relative m-0"
                    :ref="row.field"
                    style="scroll-margin: 100px;"
                  >

                    <div
                      v-if="row.field == 'address' && row.key == 'ENTER_CITY_NAME'"
                      class="address-fields"
                      :class="{
                        'is-invalid': errors[row.field],
                        'adjust-input-field': data.isLabel == 'showLabel',
                      }"
                    >
                      <AddressFill
                        :className="{
                          'is-invalid': errors[row.field],
                          'vs-form-control': true,
                        }"
                        @onChange="changeAddress"
                        :placeholder="row.placeholder"
                        :dontIncludeSubdistrict="payload.dontIncludeSubdistrict && !data.hasSubDistrict"
                        :dontIncludeZipcode="payload.dontIncludeZipcode && !data.hasSubDistrict"
                        :fieldName="row.key"
                        :fieldLabel="row.label"
                        :hasError="errors[row.field]"
                        :showLabel="data.isLabel == 'showLabel'"
                        :rules="getValidationRules(row)"
                        :addressVal="payload.address"
                        :shippingData="{'enableExcludeShipping':data.enableExcludeShipping,'excludeShipping':data.excludeShipping,'excludeShippingLocation':data.excludeShippingLocation}"
                      />

                      <!-- <div style="margin-top: 10px" class="village-checkbox">
                        <vs-checkbox v-if="row.label == 'Kota / Kecamatan'" v-model="payload.dontIncludeSubdistrict">Tanpa
                          Kelurahan</vs-checkbox>
                      </div> -->
                    </div>

                    <div
                      v-else-if="
                        row.field == 'address' && row.key == 'PROVINCE_NAME'
                      "
                      class="subAddress-fields"
                      :class="{ 'is-invalid': errors[row.field] }"
                    >
                      <ProvinceAddress
                        :className="{
                          'is-invalid': errors[row.field],
                          'vs-form-control': true,
                        }"
                        @onChange="(val) => changeAddresses(val, 'province')"
                        :value="selectedProvince"
                        :requires-city="isAddressFieldRequired('CITY_NAME')"
                        :has-city-field="isAddressFieldActive('CITY_NAME')"
                        :placeholder="row.placeholder"
                        :fieldName="row.key"
                        :fieldLabel="row.label"
                        :hasError="errors[row.field]"
                        :showLabel="data.isLabel == 'showLabel'"
                        :rules="getValidationRules(row)"
                        :isLabel="data.isLabel"
                        :formMode="data.formMode"
                        :shippingData="{'enableExcludeShipping':data.enableExcludeShipping,'excludeShipping':data.excludeShipping,'excludeShippingLocation':data.excludeShippingLocation}"
                      />
                    </div>

                    <div
                      v-else-if="
                        row.field == 'address' && row.key == 'CITY_NAME'
                      "
                      class="subAddress-fields"
                      :class="{ 'is-invalid': errors[row.field] }"
                    >
                      <CityAddress
                        :className="{
                          'is-invalid': errors[row.field],
                          'vs-form-control': true,
                        }"
                        @onChange="(val) => changeAddresses(val, 'city')"
                        :value="selectedCity"
                        :province="selectedProvince"
                        :requires-district="isAddressFieldRequired('DISTRICT_NAME')"
                        :has-district-field="isAddressFieldActive('DISTRICT_NAME')"
                        :placeholder="row.placeholder"
                        :fieldName="row.key"
                        :fieldLabel="row.label"
                        :hasError="errors[row.field]"
                        :showLabel="data.isLabel == 'showLabel'"
                        :rules="getValidationRules(row)"
                        :isLabel="data.isLabel"
                        :formMode="data.formMode"
                        :shippingData="{'enableExcludeShipping':data.enableExcludeShipping,'excludeShipping':data.excludeShipping,'excludeShippingLocation':data.excludeShippingLocation}"
                      />
                    </div>

                    <div
                      v-else-if="
                        row.field == 'address' && row.key == 'DISTRICT_NAME'
                      "
                      class="subAddress-fields"
                      :class="{ 'is-invalid': errors[row.field] }"
                    >
                      <DistrictAddress
                        :className="{
                          'is-invalid': errors[row.field],
                          'vs-form-control': true,
                        }"
                        @onChange="(val) => changeAddresses(val, 'district')"
                        :value="selectedDistrict"
                        :province="selectedProvince"
                        :city="selectedCity"
                        :requires-subdistrict="isAddressFieldRequired('SUBDISTRICT_NAME')"
                        :has-subdistrict-field="isAddressFieldActive('SUBDISTRICT_NAME')"
                        :placeholder="row.placeholder"
                        :fieldName="row.key"
                        :fieldLabel="row.label"
                        :hasError="errors[row.field]"
                        :showLabel="data.isLabel == 'showLabel'"
                        :rules="getValidationRules(row)"
                        :isLabel="data.isLabel"
                        :formMode="data.formMode"
                        :shippingData="{'enableExcludeShipping':data.enableExcludeShipping,'excludeShipping':data.excludeShipping,'excludeShippingLocation':data.excludeShippingLocation}"
                      />
                    </div>

                    <div
                    v-else-if="
                      row.field == 'address' && row.key == 'SUBDISTRICT_NAME'
                    "
                    class="subAddress-fields"
                    :class="{ 'is-invalid': errors[row.field] }"
                  >
                    <SubDistrictAddress
                      :className="{
                        'is-invalid': errors[row.field],
                        'vs-form-control': true,
                      }"
                      @onChange="(val) => changeAddresses(val, 'subdistrict')"
                      :value="selectedSubDistrict"
                      :province="selectedProvince"
                      :city="selectedCity"
                      :district="selectedDistrict"
                      :placeholder="row.placeholder"
                      :fieldName="row.key"
                      :fieldLabel="row.label"
                      :hasError="errors[row.field]"
                      :showLabel="data.isLabel == 'showLabel'"
                      :rules="getValidationRules(row)"
                      :isLabel="data.isLabel"
                      :formMode="data.formMode"
                      :shippingData="{'enableExcludeShipping':data.enableExcludeShipping,'excludeShipping':data.excludeShipping,'excludeShippingLocation':data.excludeShippingLocation}"
                    />
                  </div>

                    <div
                      v-else-if="
                        row.field == 'address' && row.key != 'ENTER_CITY_NAME'
                      "
                      class="subAddress-fields"
                      :class="{ 'is-invalid': errors[row.field] }"
                    >
                      <SubAddress
                        :className="{
                          'is-invalid': errors[row.field],
                          'vs-form-control': true,
                        }"
                        @onChange="changeAddress"
                        :placeholder="row.placeholder"
                        :dontIncludeSubdistrict="payload.dontIncludeSubdistrict"
                        :dontIncludeZipcode="payload.dontIncludeZipcode"
                        :fieldName="row.key"
                        :fieldLabel="row.label"
                        :hasError="errors[row.field]"
                        :showLabel="data.isLabel == 'showLabel'"
                        :rules="getValidationRules(row)"
                        :isLabel="data.isLabel"
                        :addressVal="payload.address"
                        :formMode="data.formMode"
                        :shippingData="{'enableExcludeShipping':data.enableExcludeShipping,'excludeShipping':data.excludeShipping,'excludeShippingLocation':data.excludeShippingLocation}"
                      />
                    </div>

                    <template v-else-if="row.isCustom">
                      <template v-if="row.fieldType == 'input'">
                        <Input
                          v-if="row.inputType == 'number'"
                          v-model="row.value"
                          type="number"
                          :placeholder="row.placeholder"
                          :label="data.isLabel == 'showLabel' ? row.label : undefined"
                          :name="row.label"
                          :rules="getValidationRules(row)"
                          :required="row.required == 'yes'"
                        />
                        <template  v-else-if="row.inputType == 'date'">
                            <InputDate
                              v-model="row.value"
                              :placeholder="row.placeholder"
                              :label="data.isLabel == 'showLabel' ? row.label : undefined"
                              :name="row.label"
                              :rules="getValidationRules(row)"
                              :required="row.required == 'yes'"
                            />
                        </template>
                        <div v-else-if="row.inputType == 'file'">
                          <InputFile
                            v-model="row.value"
                            :placeholder="row.placeholder"
                            :label="data.isLabel == 'showLabel' ? row.label : undefined"
                            :name="row.label"
                            :rules="getValidationRules(row)"
                            :required="row.required == 'yes'"
                            :overrideError="!row.value && Boolean(errors[row.field])"
                          />
                        </div>

                        <Input
                          v-else
                          v-model="row.value"
                          type="text"
                          :placeholder="row.placeholder"
                          :label="data.isLabel == 'showLabel' ? row.label : undefined"
                          :name="row.label"
                          :rules="getValidationRules(row)"
                          :required="row.required == 'yes'"
                        />
                      </template>

                      <div
                        v-else-if="row.fieldType == 'textarea'"
                        class="vs-form-control"
                      >
                        <Textarea
                          :placeholder="row.placeholder"
                          :rules="getValidationRules(row)"
                          :label="data.isLabel == 'showLabel' ? row.label : undefined"
                          :name="row.label"
                          v-model="row.value"
                          rows="3"
                          :required="row.required == 'yes'"
                        ></Textarea>
                      </div>

                      <div v-else :class="{ 'is-invalid': errors[row.field] }">
                        <Dropdown
                          v-model="row.value"
                          :placeholder="row.placeholder"
                          :rules="getValidationRules(row)"
                          :options="row.options.map(v => ({ value: v.name, label: v.name }))"
                          :label="data.isLabel == 'showLabel' ? row.label : undefined"
                          :name="row.label"
                          :use-bottom-sheet="$device ? $device.isMobile : false"
                          :bottomSheetTitle="row.label"
                          :required="row.required == 'yes'"
                        />
                      </div>
                    </template>

                    <Input
                      v-else-if="row.field == 'quantity'"
                      min="1"
                      max="100"
                      v-model="row.value"
                      type="number"
                      :placeholder="row.placeholder"
                      :label="data.isLabel == 'showLabel' ? row.label : undefined"
                      :name="row.label"
                      :rules="getValidationRules(row)"
                      :required="row.required == 'yes'"
                    />

                    <Input
                      v-else-if="row.field == 'phone'"
                      v-model="row.value"
                      :type="isMobile ? 'tel' : 'text'"
                      inputmode="numeric"
                      :placeholder="row.placeholder"
                      :label="data.isLabel == 'showLabel' ? row.label : undefined"
                      :name="row.label"
                      pattern="[0-9]*"
                      v-on:blur="() => formatPhone()"
                      :rules="getValidationRules(row)"
                      :required="row.required == 'yes'"
                    />

                    <template v-else-if="row.field == 'addressText'">
                      <Textarea
                        v-if="row.fieldType == 'textArea'"
                        :placeholder="row.placeholder"
                        :rules="getValidationRules(row)"
                        :label="data.isLabel == 'showLabel' ? row.label : undefined"
                        :name="row.label"
                        v-model="row.value"
                        rows="5"
                        :required="row.required == 'yes'"
                      ></Textarea>
                      <Input
                        v-else
                        v-model="row.value"
                        type="text"
                        :placeholder="row.placeholder"
                        :label="data.isLabel == 'showLabel' ? row.label : undefined"
                        :name="row.label"
                        :rules="getValidationRules(row)"
                        :required="row.required == 'yes'"
                      />
                    </template> 

                    <Input
                      v-else
                      v-model="row.value"
                      type="text"
                      :placeholder="row.placeholder"
                      :label="data.isLabel == 'showLabel' ? row.label : undefined"
                      :name="row.label"
                      :rules="getValidationRules(row)"
                      :required="row.required == 'yes'"
                    />

                    <div v-if="errors[row.field] && row.field == 'address'" class="invalid-feedback mt-5px">
                      {{ payload[row.field] && !payload[row.field][row.key.replace('_NAME', '')] ? errors[row.field] : !payload[row.field] ? errors[row.field] : '' }}
                    </div>
                    <div v-else-if="errors[row.field]" class="invalid-feedback mt-5px">
                      {{ errors[row.field] }}
                    </div>
                  </div>
                </template>
              </template>
            </div>
          </div>
        </no-ssr>
      </template>
     

      <!-- SAVE INFORMATION -->
      <template v-if="displayDiv(posName, 'saveThisInformation') && !data.saveInfoWithoutEnable">
        <div
          v-if="data.isSaveInfoNextTime"
          class="checkout-content--right__feature save-information"
        >
       
          <vs-checkbox @click="onSaveDataCheckbox()">
            <div style="text-align: -webkit-left;">
              {{ data.saveInfoLabel ? data.saveInfoLabel : $t("common.saveInfoNextTime") }}
            </div>
            
            <!-- {{ $t("common.saveInfoNextTime") }} -->
          </vs-checkbox>
        
        </div>
      </template>

      <!-- START SHIPPING -->

      <!-- SHIPPING AUTOMATED -->
      <div
        v-if="
          data.addShipping &&
          (payload.payment === 'COD' ? data.shippingCOD.shippingType === 'automated' : data.shippingType === 'automated') &&
          payload.address &&
          courierOptionDataFinal &&
          courierOptionDataFinal.length > 0 &&
          displayDiv(posName, 'shipping') &&
          (courierOptionDataFinal.length > 1 ||
            (courierOptionDataFinal.length == 1 && !shippingHideView))
        "
        class="checkout-content--right__feature checkout-content--right__shipping--automated"
      >
        <!-- Pre Order -->
        <div v-if="data.preOrder != undefined && data.preOrder.isActive"  class="pre-order flex items-center" style="padding-top: 8px; padding-bottom: 8px;">
          <img src="@/assets/icons/calendar-wait.svg" alt="Calendar" />
          <span class="fs-13 fw-500">{{ preOrderText }}</span>
        </div>
        <h2 class="text--subtitle">{{ data.titleShipping }}</h2>
        <div class="row">
          <div class="col-12" ref="deliveryCourierPrice">
            <Dropdown
              v-if="courierOptionDataFinal.length > 0"
              v-model="deliveryCourierPrice"
              :placeholder="'Pilih Ekspedisi'"
              :options="courierOptionDataFinal.map(v => ({
                value: v.value,
                label: v.label.split('-').length ? v.label.split('-')[0]+'-'+v.label.split('-')[1] : '',
                disabled: loadEstimateDelivery(v).unsupported || (payload.payment === 'COD' && loadEstimateDelivery(v).unsupportedCod),
                ...v,
              }))"
              @change="changeCouriePrice"
              name="Pengiriman"
              :use-bottom-sheet="$device ? $device.isMobile : false"
              bottomSheetTitle="Pengiriman"
              bottomSheetClass="select-shipping"
              bottomSheetSelector="#container-mobile"
              hide-check-mark
              :maxHeight="'300px'"
              custom-class-options="dropdown-options-shipping"
            >
              <template #trigger="{ displayedValue }">
                {{ showSelectedLabel(displayedValue) }}
              </template>
              <template #item="{ item }">
                <div class="courierOptionsWithPrice">
                  <img :src="loadShippingImage(item.imageSrc)" :alt="item.label" height="24px" width="24px">
                  <div class="left_content">
                    <div class="d-flex">
                      <h6 class="types-ofcourier m-0 mb-1" :data-disabled="item.disabled">
                        {{ item.label.split('-').length ? item.label.split('-')[0]+'-'+item.label.split('-')[1] : '' }}
                      </h6>
                      <div v-if="data.multiShipFromAddress && isCheapest(item.label, courierOptionDataFinal)">
                        <span class="cheapest-label ml-1">{{ $t("common.cheapest") }}</span>
                      </div>
                    </div>
                    <p v-if="item.shipFromAddress" class="shipping-address m-0">({{ item.shipFromAddress ? 'Dikirim dari ' + item.shipFromAddress.CITY_NAME : ''}})</p>
                    <p v-else class="shipping-address m-0">{{ $t('common.unreachableAddress') }}</p>
                  </div>
                  <div>
                    <div
                      v-if="(data.showPayment && (loadEstimateDelivery(item).unsupported || loadEstimateDelivery(item).unsupportedCod)) || (!data.showPayment && loadEstimateDelivery(item).unsupported)"
                      class="unsupported-badge"
                    >
                      <img src="@/assets/icons/x-circle-contained.svg" alt="x">
                      {{ loadEstimateDelivery(item).unsupported ? 'COD & NON COD' : 'COD' }}
                    </div>
                    <h6 v-else class="shipping-price m-0">{{ item.label.split('-').length ? item.label.split('-')[2] : 'Rp0'}}</h6>
                  </div>
                </div>
              </template>
            </Dropdown>
            <!-- <vs-select
              class="vs-form-control"
              v-model="deliveryCourierPrice"
              :placeholder="'Pilih Ekspedisi'"
              @change="changeCouriePrice"
              :class="{ 'is-invalid': errors['deliveryCourierPrice'] }"
              v-if="courierOptionDataFinal.length > 0"
              :key="id"
            >
              <vs-option
                v-for="(options, ind) in courierOptionDataFinal"
                :label="options.label2"
                :value="options.value"
                v-bind:key="`shipping-${ind}`"
                class="courierOptionsWithPrice"
              >
                <div class="left_content">
                  <div class="d-flex items-center">
                    <h6 class="types-ofcourier m-0">{{ options.label.split('-').length ? options.label.split('-')[0]+'-'+options.label.split('-')[1] : '' }}</h6>
                    <div v-if="data.multiShipFromAddress && isCheapest(options.label,courierOptionDataFinal)">
                      <span class="cheapest-label ml-1">{{ $t("common.cheapest") }}</span>
                    </div>
                  </div>
                  <p v-if="options.shipFromAddress" class="shipping-address m-0">({{ options.shipFromAddress ? 'Dikirim dari ' + options.shipFromAddress.CITY_NAME : ''}})</p>
                </div>
                <div>
                  <h6 class="shipping-price m-0">{{ options.label.split('-').length ? options.label.split('-')[2] : 'Rp0'}}</h6>
                </div>
              </vs-option>
            </vs-select> -->
            <div
              v-if="errors['deliveryCourierPrice']"
              class="invalid-feedback mt-5px"
            >
              {{ errors["deliveryCourierPrice"] }}
            </div>

            <!-- <vs-select
              v-if="
                delivery.jne.length ||
                delivery.sicepat.length ||
                delivery.sap.length ||
                delivery.iDexpress.length
              "
              class="vs-form-control"
              v-model="payload.deliveryCourier"
            >
              <vs-option
                :style="delivery.jne.length ? '' : 'display: none'"
                :label="'JNE'"
                :value="'jne'"
                >JNE
              </vs-option>
              <vs-option
                :style="delivery.sicepat.length ? '' : 'display: none'"
                :label="'SiCepat'"
                :value="'sicepat'"
              >
                SiCepat</vs-option
              >
              <vs-option
                :style="delivery.sap.length ? '' : 'display: none'"
                :label="'Sap'"
                :value="'sap'"
                >Sap
              </vs-option>
              <vs-option
                :style="delivery.iDexpress.length ? '' : 'display: none'"
                :label="'iDexpress'"
                :value="'iDexpress'"
                >iDexpress
              </vs-option>
              <vs-option
                :style="delivery.jNt.length ? '' : 'display: none'"
                :label="'J&T Express'"
                :value="'jNt'"
                >J&T Express
              </vs-option>
            </vs-select> -->
          </div>
          <!-- <div class="col-6">
            <div
              v-if="delivery[payload.deliveryCourier].length"
              class="fake-select-value"
              style="top: 9px; left: 26px"
            >
              REG - Rp{{
                payload.deliveryPrice
                  ? payload.deliveryPrice
                  : delivery[payload.deliveryCourier][0].price | g_number_format
              }}
            </div>
            <vs-select
              :key="'pr' + i"
              v-for="(price, i) in delivery[payload.deliveryCourier]"
              class="vs-form-control"
              v-model="payload.deliveryPrice"
            >
              <vs-option :value="price.price"
                >REG - Rp{{ price.price | g_number_format }}</vs-option
              >
            </vs-select>
          </div> -->
        </div>
      </div>

      <!-- SHIPPING FLAT AND FREE-->
      <no-ssr>
      <div
        v-if="
          data.addShipping &&
          (payload.payment === 'COD' ? data.shippingCOD.shippingType !== 'automated' : data.shippingType !== 'automated') &&
          displayDiv(posName, 'shipping')
        "
        class="checkout-content--right__feature checkout-content--right__shipping--flat-or-free"
      >
        <template v-if="payload.payment === 'COD' ? data.shippingCOD.shippingType === 'flat' : data.shippingType == 'flat'">
          <label class="text--label-field">{{ data.titleShipping }}</label>
          <div class="attributes mt-10" style="padding: 15px">
            <div class="attribute flex justify-between items-center">
              <div class="d-flex justify-content-center">
                <div class="flat-free-title">
                  <span
                    v-if="(payload.payment === 'COD' ? data.shippingCOD.shippingType === 'flat' : data.shippingType == 'flat') && 
                    (payload.payment === 'COD' ? data.shippingCOD.flatShippingPrice : data.flatShippingPrice)"
                  >
                    Rp{{ payload.payment === 'COD' ? data.shippingCOD.flatShippingPrice : data.flatShippingPrice | g_number_format }}
                  </span>
                </div>
                <!-- display Strikethrough Shipping price-->
                <div class="text-danger ml-1"
                  v-if="freeDeliveryPrice !== '' && data.isShowStrikethrough && ((payload.payment === 'COD' ? Number(data.shippingCOD.flatShippingPrice || 0) : Number(data.flatShippingPrice || 0)) < freeDeliveryPrice)"
                  style="text-decoration: line-through;">
                  Rp{{ freeDeliveryPrice | g_number_format }}
                </div>
              </div>

              <div class="shippingType-title">
                {{ $t('common.shipping') }} {{ payload.payment === 'COD' ? data.shippingCOD.shippingType : data.shippingType  }}
              </div>
            </div>
          </div>
        </template>

        <!-- FREE -->
        <template v-if="payload.payment === 'COD' ? data.shippingCOD.shippingType === 'free' : data.shippingType == 'free'">
          <label class="text--label-field">{{ data.titleShipping }}</label>
          <div class="attributes mt-10" style="padding: 15px">
            <div class="attribute flex justify-between items-center">

              <div class="d-flex justify-content-center">
                <div class="flat-free-title">Rp0</div>
                <!-- display Strikethrough Shipping price-->
                <div class="text-danger ml-1" v-if="freeDeliveryPrice != '' && data.isShowStrikethrough" style="text-decoration: line-through;"> Rp{{ freeDeliveryPrice | g_number_format }}
                </div>
              </div>
              
              <div class="free-shippingType-title">
                {{ payload.payment === 'COD' ? data.shippingCOD.shippingType : data.shippingType }} {{ $t('common.shipping') }}
              </div>
            </div>
          </div>
        </template>
      </div>
      </no-ssr>

      <!-- END SHIPPING -->
   
      <template v-if="displayDiv(posName, 'otherContent')">
        <div
          v-if="data.showOtherContent && data.otherContent" 
          class="OtherContent_wrapper">
          <div 
            v-if="data.otherContent"
            class="add-product-preview-right-description text-left text-break"
            v-html="data.otherContent"></div>
        </div>
      </template>
    
      <!-- PAYMENT METHOD -->
      <no-ssr>
        <template
          v-if="
            displayDiv(posName, 'payment') &&
            data.showPayment &&
            data.paymentType &&
            data.paymentType.find((p) => p.active) &&
            (data.paymentType.filter((p) => p.active).length > 1 ||
              !showPaymentHideView)
          "
        >
          <div
            class="checkout-content--right__feature embed-checkout-right-payment embed-payment-method"
            :class="isSizeWindow ? 'after_bg_payment' : ''"
          >
            <h2 class="text--subtitle">{{ data.titlePayment }}</h2>
            <div class="attributes embed-paymentType mt-10">
              <template
                v-for="(pType, ind) in paymentType"
              >
                <div
                  v-bind:key="ind"
                  v-if="pType.type != 'E-Payment'"
                  class="attribute flex justify-between items-center"
                  @click="handlePaymentSelection(pType.type, pType.name, !isInitial && !isAddressUnsupported && isAddressUnsupportedCod && pType.type == 'COD')"
                >
              
                  <vs-radio :val="pType.type" v-model="payload.payment" :disabled="!isInitial && !isAddressUnsupported && isAddressUnsupportedCod && pType.type == 'COD'">
                    <div class="flex items-center justify-between gap-10px">
                      <div class="flex items-center gap-10px" :style="{ color: !isInitial && !isAddressUnsupported && isAddressUnsupportedCod && pType.type == 'COD' ? '#BFCEE0' : '' }">
                        <img
                          width="42px"
                          height="30px"
                          alt=""
                          class="payment-image mr-10"
                          :src="
                            pType.type == 'COD'
                              ? require('@/assets/icons/Payments/payment-cod.png')
                              : require('@/assets/icons/Payments/payment-bank_transfer.png')
                          "
                        />
                        {{ $t(`payment.type.${pType.type}`) }}
                      </div>
                      <div v-if="!isInitial && !isAddressUnsupported && isAddressUnsupportedCod && pType.type == 'COD'" class="unsupported-badge">
                        <img src="@/assets/icons/x-circle-contained.svg" alt="x">
                        {{ $t('common.unreachableAddress') }}
                      </div>
                    </div>
                  </vs-radio>
              
                </div>
                <template v-for="(elem, i) in data.epaymentSettings" v-else>
                  <div
                    class="attribute flex justify-between items-center"
                    :key="ind + i"
                    v-if="elem.active"
                    @click="handlePaymentSelection(elem.id, 'E-Payment')"
                    :style="{ borderColor: payload.payment === elem.id ? 'transparent' : '#E0E9F4' }"
                  >
                
                  <vs-radio
                  v-bind:key="i"
                  :val="elem.id"
                  v-model="payload.payment"
                  >
                    <div class="flex items-center justify-between gap-10px">
                      <div class="flex items-center gap-10px">
                        <img
                            width="42px"
                            height="30px"
                            alt=""
                            class="payment-image mr-10"
                            :src="
                              pType.id == 'COD'
                                ? require('@/assets/icons/Payments/payment-bank_transfer.png')
                                : require('@/assets/icons/Payments/' +
                                    elem.id +
                                    '.png'
                                    ? '@/assets/icons/Payments/' + elem.id + '.png'
                                    : '@/assets/icons/Payments/' + elem.id + '.svg')
                            "
                          />
                          <div>
                            <p class="m-0" :style="{ color: !isInitial &&!isAddressUnsupported && pType.type == 'COD' ? '#BFCEE0' : '' }">{{ elem.label }}</p>
                            <template v-if="data.ePaymentFeePaidBy === 'buyer'">
                              <p class="m-0 e-payment-admin-fee" v-if="elem.id === 'gopay'">{{ $t('settings.adminEPayFeeGopay') }}</p>
                              <p class="m-0 e-payment-admin-fee" v-else-if="elem.id === 'QRIS'">{{ $t('settings.adminEPayFeeQRIS') }}</p>
                              <p class="m-0 e-payment-admin-fee" v-else-if="elem.id === 'creadit_card'">{{ $t('settings.adminEPayFeeCreditCard') }}</p>
                              <p class="m-0 e-payment-admin-fee" v-else>{{ $t('settings.adminEPayFeeOther') }}</p>
                            </template>
                          </div>
                        </div>
                      </div>
                    </vs-radio>
                  
                  </div>
                  <div
                    :key="'payment-'+ind + i"
                    v-if="payload.payment === elem.id"
                    class="fw-500 text-center"
                    style="background-color: #D6E0F7; padding: 8px; color: #113B98; margin: 0 -15px;"
                    :style="{ fontSize: isMobile ? '11px' : '12px' }"
                  >
                    {{ $t('settings.processByMidtrans') }}
                  </div>
                </template>
              </template>
            </div>
          </div>
        </template>
      </no-ssr>
  
      <!-- BUMP PRODUCT -->
      <template v-if="displayDiv(posName, 'bump')">
        <div
          v-if="
            data.showBumpProduct && data.isBump && data.bumpArray.length > 0
          "
          class="checkout-content--right__feature checkout-content--right__bump"
        >
          <div
            v-for="(bumpData, i) in data.bumpArray"
            :key="i"
            class="embed-checkout-right__bump__item"
            :style="
            bumpData.bumpBorder &&
            bumpData.bumpColor &&
            bumpData.bumpBackground &&
            `background-color:${bumpData.bumpBackground};
             border-color:${ bumpData.bumpBorder};
             color:${ bumpData.bumpColor};
            `
          
          "
          @click="(e)=>{addBumpOrder(e,bumpData)}"
          >
            <div
              class="bump__item__main"
              :class="
                bumpData.bumpImage ? 'bump__item__main--thumbnail-show' : ''
              "
            >
              <div
                class="bump__item__main__thumbnail"
                v-if="bumpData.bumpImage"
              >
                <img
                  style="min-width: 75px"
                  :src="
                    getSizedImageUrl(bumpData.bumpImage,'thumbnail','product-images')
                  "
                />
              </div>
              <div class="bump__item__main__info">
                <div class="bump__item__main__info__title-price">
                  <p :style="           
                    bumpData.bumpColor &&           
                    `color:${ bumpData.bumpColor};
                    ` ">{{ bumpData.bumpName }}</p>
                  <p :style="           
                    bumpData.bumpColor &&           
                    `color:${ bumpData.bumpColor};
                    ` ">Rp {{ bumpData.bumpPrice | g_number_format }}</p>
                </div>
                <p
                  v-if="bumpData.bumpDescription"
                  class="bump__item__main__info__description"
                  :style="           
                    bumpData.bumpColor &&           
                    `color:${ bumpData.bumpColor};
                    ` "
                >
                  {{ bumpData.bumpDescription }}
                </p>
              </div>
            </div>

            <div class="bump__item__action--buy" :style="`border-color: ${bumpData.bumpBorder}`">
              <div
                class="d-flex flex-row bump_input_wrapper justify-content-between w-100"
              >
             
                <vs-checkbox
                  v-model="selectedbumpArray"
                  :key="i"
                  :val="bumpData"
                >
                 <label :style="           
                    bumpData.bumpColor &&           
                    `color:${ bumpData.bumpColor};
                    ` ">{{ bumpData.bumpText3 }}</label> 
                </vs-checkbox>
                <input
                  type="hidden"
                  disabled
                  class="checkbox-text bumpText3 ml-2"
                  v-model="bumpData.bumpText3"
                />
             
              </div>
            </div>
          </div>
        </div>
      </template>
    
      <!-- LEFT COMPONENT -->
      <no-ssr>
      <div
        v-if="
          data.templateType == 'RightSidebar' &&
          data.themeType == 'Classic' &&
          isSizeWindow &&
          !embed
        "
      >
        <!-- Buybutton in between -->
        <!-- <template v-if="displayDiv(posName, 'buyButton')">
          <div :style="isSizeWindow && cartSummary.length && data.cartOrder ? 'padding-bottom:20px;' : 'flex: 0 0 100%; width: 100%; padding-bottom:20px; margin: auto;'" v-if="displayDiv(posName, 'buyButton')">
            <div v-if="isDisabled" style="border-radius: 5px; background-color: #e0e0e0"
              class="w-100 px-2 py-1 text-white text-cente">
              <div style="color: rgba(0, 0, 0, 0.26)" class="flex items-center justify-center">
                Stok Produk Kosong
              </div>
            </div>
            <div v-else-if="showCaptcha && !verifiedCaptcha" style="border-radius: 5px; background-color: #e0e0e0; "
              class="w-100 px-2 py-1 text-white text-center">
              <div style="color: rgba(0, 0, 0, 0.26); min-height: 55px" class="flex items-center justify-center">
              {{ data.buyButtonText }}
              </div>
            </div>
            <div v-else @click="() => !loadingPrice && save()"
              class="flex justify-center items-center w-100 text-white text-center pointer"
              style="min-height: 55px; border-radius: 8px;"
              :style="'background-color: ' + data.buyButtonStyle + (loadingPrice ? '; opacity: 0.5;' : '')">
              <span :class="{
                'bold-buy-btn': data.boldBuyButtonText,
                'small-buy-btn': data.buyButtonFontSize == 'Small',
                'medium-buy-btn': data.buyButtonFontSize == 'Medium',
                'large-buy-btn': data.buyButtonFontSize == 'Large',
                'extra-large-buy-btn': data.buyButtonFontSize == 'Extra-Large',
              }">
                {{ data.buyButtonText }} </span>
                <div v-if="data.isAddIcon" class="ml-2 d-flex justify-content-center">
                    <vue-feather :type="data.selectedIconName"></vue-feather>
                </div>
            </div>
          </div>
        </template> -->
        <Left
          :selectedbumpArray="selectedbumpArray"
          :data="data"
          :form="form"
          :cartTotal="cartTotal"
          :payload="payload"
          :codPrice="codPrice"
          :priceWithoutWhosale="priceWithoutWhosale"
          :loadingPrice="loadingPrice"
          :delivery="delivery"
          :price="price"
          :VATPrice="VATPrice"
          :weight="weight"
          :quantity="quantity"
          @updateCartSummary="removeFromCart"
          :totalPrice="totalPrice"
          :isSizeWindow="isSizeWindow"
          :cartSummary="cartSummary"
          @onSave="save"
          :pos="pos"
          :posName="posName"
          :posIndex="posIndex"
          :productImages="productImages"
          :variantImageIndex="variantImageIndex"
          :shippingDiscountValue="shippingDiscountValue"
        />
      </div>

      <!-- COUPON -->    
    <template v-if="data.showCoupon && displayDiv(posName, 'coupon')">
      <Coupon :data="data" :payload="payload" @selectDiscount="selectDiscount" @updateDiscountLists="updateDiscountLists" @clearDiscountCode="clearDiscountCode" :discountLists="discountLists" :totalQuantity="totalQuantity" :cartSummary="cartSummary" :totalPrice="totalPrice" :price="price"/>
    </template> 


      <!-- BUY BUTTON BEFORE SUMMERY -->
      <template v-if="displayDiv(posName, 'buyButton')">
        <div v-if="data.summaryPlacement == 'After Buy Button'">
          <div
            class="checkout-content--right__feature embed-checkout-right-button embed-buyButton flex align-items-center grid-gap15px"
            v-if="
              data.themeType == 'Classic' ||
              (data.themeType != 'Classic' &&
                data.templateType != 'RightSidebar') ||
              (data.themeType != 'Classic' &&
                data.templateType == 'RightSidebar' &&
                !isSizeWindow)
            "
          >
             <div
              v-if="isSizeWindow && cartSummary.length && data.cartOrder"
              style="
                flex: 0 0 56px;
                width: 56px;
                background: #ffffff;
                border: 1px solid #bfcee0;
                border-radius: 8px;
                max-height: 56px;
                height: 100%;
                padding: 17px;
              "
              @click="openCartSummary()"
            >
              <div
                class="flex justify-content-center align-items-center position-relative"
              >
                <div class="cart-counter">
                  {{ cartSummary ? cartSummary.length : 0 }}
                </div>
                <img src="@/assets/icons/Cart-bucket.svg" alt="" />
              </div>
            </div>

            <div
              :style="
                isSizeWindow && cartSummary.length && data.cartOrder
                  ? 'flex: 0 0 calc(100% - 70px); width: calc(100% - 70px);'
                  : 'flex: 0 0 100%; width: 100%;'
              "
            >
              <div
                v-if="isDisabled"
                style="
                  border-radius: 5px;
                  background-color: #e0e0e0;
                  min-height: 55px;
                "
                class="buy-button w-100 px-2 py-1 text-white text-center"
                :data-size="buyButton.buyButtonFontSize || 'Medium'"
              >
                <span
                  class="flex items-center justify-center"
                  style="color: rgba(0, 0, 0, 0.26)"
                  :class="{
                    'bold-buy-btn': buyButton.boldBuyButtonText,
                    'small-buy-btn': buyButton.buyButtonFontSize == 'Small',
                    'medium-buy-btn': buyButton.buyButtonFontSize == 'Medium',
                    'large-buy-btn': buyButton.buyButtonFontSize == 'Large',
                    'extra-large-buy-btn':
                      buyButton.buyButtonFontSize == 'Extra-Large',
                  }"
                >
                  {{ $t('common.stockEmpty') }}
                </span>
              </div>
              <div
                v-else-if="showCaptcha && !verifiedCaptcha"
                style="
                  border-radius: 5px;
                  background-color: #e0e0e0;
                  min-height: 55px;
                "
                class="buy-button w-100 px-2 py-1 text-white text-center"
                :data-size="buyButton.buyButtonFontSize || 'Medium'"
              >
                <span
                  style="color: rgba(0, 0, 0, 0.26)"
                  class="flex items-center justify-center"
                  :class="{
                    'bold-buy-btn': buyButton.boldBuyButtonText,
                    'small-buy-btn': buyButton.buyButtonFontSize == 'Small',
                    'medium-buy-btn': buyButton.buyButtonFontSize == 'Medium',
                    'large-buy-btn': buyButton.buyButtonFontSize == 'Large',
                    'extra-large-buy-btn':
                      buyButton.buyButtonFontSize == 'Extra-Large',
                  }"
                >
                  {{ buyButton.buyButtonText }}
                </span>
              </div>

              <!-- for show floating button  -->
              <div
                v-else-if="isSizeWindow && data.floatingButton"
                @click="() => !loadingPrice && save()"
                class="flex justify-center items-center pointer text-white m_float_btn"
                style="min-height: 55px; border-radius: 8px"
                :style="
                  'background-color: ' +
                  buyButton.buyButtonStyle +
                  ';border: 1px solid ' +
                  buyButton.buyButtonStyle +
                  (isBuyButtonLoading | loadingPrice
                    ? '; opacity: 0.5; pointer-event: none; cursor: default;'
                    : '')
                "
                :disabled="isBuyButtonLoading || loadingPrice"
              >
                <div
                  v-if="data.isAddIcon"
                  class="d-flex justify-content-center"
                >
                  <img
                    v-if="isWhatsappIcon(data.selectedIconName)"
                    src="@/assets/icons/whatsapp-link.svg"
                    alt="WhatsApp"
                    width="24"
                    height="24"
                  />
                  <vue-feather v-else :type="data.selectedIconName"></vue-feather>
                </div>
                <div v-else class="d-flex justify-content-center">
                  <i data-v-07452373="" data-v-62b2fe6e="" data-name="shopping-cart" data-tags="ecommerce,cart,purchase,store" data-type="shopping-cart" class="feather feather--shopping-cart"><svg data-v-07452373="" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-shopping-cart feather__content"><circle cx="9" cy="21" r="1"></circle><circle cx="20" cy="21" r="1"></circle><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path></svg></i>
                </div>
              </div>

              <button
                v-else
                @click="() => !loadingPrice && save()"
                class="buy-button buy-button__default"
                :class="[
                  buyButton.isAddIcon ? 'buy-button__default--show-icon' : '',
                  isBuyButtonLoading ? 'buy-button__default--loading' : '',
                  (data.variablePrices.length>0 && !isVariableItemSelected) ? 'buy-button__default--disabled' :''
                ]"
                :style="
                  'background-color: ' +
                  buyButton.buyButtonStyle +
                  ';' +
                  'border: 1px solid ' +
                  buyButton.buyButtonStyle
                "
                :disabled="isBuyButtonLoading || loadingPrice || (data.variablePrices.length>0 && !isVariableItemSelected)"
                :data-size="buyButton.buyButtonFontSize || 'Medium'"
              >
                <div class="buy-button__default__ic-loading">
                  <img
                    src="@/assets/icons/ic-loading-button.svg"
                    alt="loading"
                  />
                </div>
                <span
                  :class="{
                    'bold-buy-btn': buyButton.boldBuyButtonText,
                    'small-buy-btn': buyButton.buyButtonFontSize == 'Small',
                    'medium-buy-btn': buyButton.buyButtonFontSize == 'Medium',
                    'large-buy-btn': buyButton.buyButtonFontSize == 'Large',
                    'extra-large-buy-btn':
                      buyButton.buyButtonFontSize == 'Extra-Large',
                  }"
                >
                  {{ buyButton.buyButtonText }}
                </span>
                <template v-if="buyButton.isAddIcon">
                  <img
                    v-if="isWhatsappIcon(buyButton.selectedIconName)"
                    src="@/assets/icons/whatsapp-link.svg"
                    alt="WhatsApp"
                    width="24"
                    height="24"
                  />
                  <vue-feather v-else :type="buyButton.selectedIconName"></vue-feather>
                </template>
              </button>
            </div>
          </div>
        </div>
      </template>
   
      <!-- Order summary for no sidebar -->
      <template v-if="displayDiv(posName, 'orderSummary')">
        <div
          v-if="
            data.orderSummary &&
            payload &&
            data.themeType == 'Classic' &&
            ((data.templateType == 'NoSidebar' || data.templateType == 'NoSidebarNarrowCanvas') ||
              (data.templateType !== 'NoSidebar' && data.templateType !== 'NoSidebarNarrowCanvas' && embed))
          "
          class="checkout-content--right__feature pp-order-summary"
          :class="
            data.orderSummary &&
            payload &&
            data.themeType == 'Classic' &&
            data.templateType == 'NoSidebar'
              ? 'pp-order-summary--no-sidebar'
              : ''
          "
        >
          <h2 class="pp-order-summary__title">{{ $t('common.orderDetails') }}</h2>
          <!-- START ORDER SUMMARY LIST -->
          <div class="pp-order-summary__list">
            <!-- PRODUCT -->
            <div
              v-if="data.type == 'simple'"
              class="pp-order-summary__list__item"
            >
              <div
                class="common-font product-name product-title-shrink-checkout nosidebar"
              >
                {{ data.name }}
                <span
                  >({{
                    data.enableProductOptions &&
                    data.addQuantity &&
                    cartQuantity >= 1
                      ? cartQuantity
                      : noProductOptionQty
                  }}x)</span
                >
              </div>
              <div
                v-if="data.type == 'simple'"
                class="text-right justify-between"
              >
                <div class="common-font regular_price">
                  Rp{{ price | g_number_format }}
                </div>
                <div
                  class="common-font sale_price text-danger left"
                  style="text-decoration: line-through"
                  v-if="data.priceCompare && quantity && data.type == 'simple'"
                >
                  Rp{{ (quantity * data.price) | g_number_format }}
                </div>
                <div
                  v-else-if="parseInt(priceWithoutWhosale) !== parseInt(price)"
                  class="text-danger def common-font sale_price"
                  style="text-decoration: line-through"
                >
                  Rp{{ priceWithoutWhosale | g_number_format }}
                </div>
              </div>
            </div>

            <!-- VARIANT ORDER -->
            <div
              v-if="data.type != 'simple'"
              class="pp-order-summary__list__item pp-order-summary__list__item--variant-order"
            >
              <div
                class="common-font product-name product-title-shrink-checkout nosidebar"
              >
                {{ data.name }}
                <span v-if="totalQtyMultipleVariant > 0">({{ totalQtyMultipleVariant }}x)</span>
              </div>
              <!-- VARIANT ORDER SINGLE -->
              <template
                v-if="
                  !data.multiplyVariations ||
                  data.type == 'simple' ||
                  (data.multiplyVariations && data.cartOrder)
                "
              >
                <template
                  v-if="
                    cartSummary &&
                    cartSummary.length > 0 &&
                    data.multiplyVariations
                  "
                >
                  <template v-for="(elem, i) in cartSummary">
                    <div
                      v-if="elem && elem.qty"
                      v-bind:key="i"
                      class="item--variant-order__cart--qty"
                    >
                      <div class="item--variant-order__elem-qty__info">
                        <div class="flex justify-start" style="flex: 1 1 auto;">
                          <div style="padding-right: 5px">
                            ({{
                              cartSummary[i] ? cartSummary[i].qty : elem.qty
                            }}x)
                          </div>
                          <div class="single-variant">
                            <div
                              v-for="(elemChild, j) in elem.items"
                              v-bind:key="j + 'p'"
                            >
                              {{ j.substring(0, j.length - 1) }}
                              <span style="font-weight: 600;">{{ elemChild.name }}</span>
                            </div>
                          </div>
                        </div>
                        <!-- <div style="text-align: end">
                          <div
                            class="text-danger"
                            style="text-decoration: line-through"
                            v-if="
                              getSubPrice(elem) !==
                              elem.priceOriginal * elem.qty
                            "
                          >
                            Rp{{
                              (elem.priceOriginal * elem.qty) | g_number_format
                            }}
                          </div>
                          <div>Rp{{ getSubPrice(elem) | g_number_format }}</div>
                        </div> -->
                        <div v-if="elem.priceOriginal">
                          <div style="text-align: end">
                            <div>
                              Rp{{ getSubPrice(elem) | g_number_format }}
                            </div>
                            <div
                              class="text-danger"
                              style="text-decoration: line-through"
                              v-if="
                                getSubPrice(elem) !==
                                elem.priceOriginal * elem.qty
                              "
                            >
                              Rp{{ (elem.priceOriginal * elem.qty) | g_number_format }}
                            </div>
                          </div>
                        </div>

                        <!-- VARIANT DELETE BUTTON -->
                        <div
                          v-if="cartSummary.length > 1"
                          class="delete-variant text-right ml-5px removeFromCart"
                        >
                          <img
                            @click="removeFromCart(i)"
                            src="@/assets/icons/Delete-grey.svg"
                            alt=""
                            class="pointer"
                          />
                        </div>
                        
                      </div>
                    </div>
                  </template>
                </template>

                <div
                  class="item--variant-order__cart--default flex justify-between"
                  v-else
                >
                  <div class="flex justify-start">
                    <div style="padding-right: 5px">
                      ({{
                        data.addQuantity && cartQuantity >= 1
                          ? cartQuantity
                          : noProductOptionQty
                      }}x)
                    </div>
                    <div class="single-variant left">
                      <div
                        :key="l + 'p'"
                        v-for="(vprice, l) in Object.keys(
                          payload.variablePrices
                        )"
                      >
                        {{ vprice.substring(0, vprice.length - 1) }}
                        <span style="font-weight: 600;">{{ payload.variablePrices[vprice].name }}</span>
                      </div>
                    </div>
                  </div>
                  <div class="text-right w-50 ct-1">
                    <div>Rp{{ price | g_number_format }}</div>
                    <div
                      class="text-danger"
                      style="text-decoration: line-through"
                      v-if="parseInt(priceWithoutWhosale) !== parseInt(price)"
                    >
                      Rp{{ priceWithoutWhosale | g_number_format }}
                    </div>
                  </div>
                </div>
              </template>

              <!-- VARIANT ORDER MULTIPLY VARIATION -->
              <template v-else>
                <template v-for="(attr, i) in data.variablePrices">
                  <div
                    v-if="attr.qty > 0"
                    :key="'f' + i"
                    class="item--variant-order__cart--qty"
                  >
                    <div class="item--variant-order__elem-qty__info">
                      <div class="flex justify-start" style="flex: 1 1 auto;">
                        <div style="padding-right: 5px">({{ attr.qty }}x)</div>
                        <div class="single-variant">
                          <div 
                            v-for="(elemChild, j) in attr.attrs"
                            v-bind:key="elemChild.name + elemChild.value + j"
                          >
                            {{elemChild.name.substring(0, elemChild.name.length - 1) }}
                            <span style="font-weight: 600;">{{ elemChild.value }}</span>
                          </div>
                          <!-- {{
                            attr.attrs
                              .map(
                                (n) =>
                                  n.name.substring(0, n.name.length - 1) +
                                  " : " +
                                  n.value
                              )
                              .join(",")
                          }} -->
                        </div>
                      </div>
                      <div style="text-align: end">
                        <div>
                          Rp{{ getSubPrice(attr) | g_number_format }}
                        </div>
                        <div
                          v-if="getSubPrice(attr) !== attr.price * attr.qty"
                          class="text-danger"
                          style="text-decoration: line-through"
                        >
                          Rp{{ (attr.price * attr.qty) | g_number_format }}
                        </div>
                      </div>
                      <div
                        v-if="attr.qty > 0"
                        class="delete-variant text-right removeFromCart ml-5px"
                      >
                        <img
                          @click="deleteVariant(i)"
                          src="@/assets/icons/Delete-grey.svg"
                          alt=""
                          class="pointer"
                        />
                      </div>
                    </div>
                  </div>
                </template>
              </template>
            </div>

            <!-- BUMP -->
            <div
              v-if="data.isBump && selectedbumpArray.length > 0"
              class="pp-order-summary__list__item pp-order-summary__list__item--bump"
              style="border-bottom-style: solid;"
            >
              <div class="item--bump__label">{{ $t('common.bumpProduct') }}</div>
              <div class="item--bump__list">
                <div
                  v-for="(data, i) in selectedbumpArray"
                  :key="i"
                  class="item--bump__list__product"
                >
                  <div>{{ data.bumpName }}</div>
                  <div class="flex items-center gap-10px flexshrink">
                    <div>Rp{{ data.bumpPrice | g_number_format }}</div>
                    <div
                      @click="deleteBumpProduct(i)"
                      role="button"
                      class="delete-variant text-right removeFromCart ml-10 flexshrink"
                    >
                      <img
                        src="@/assets/icons/Delete-grey.svg"
                        alt=""
                        class="pointer"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- SHIPPING COST AUTOMATES -->
            <div
              v-if="
                data.addShipping &&
                (payload.payment === 'COD' ? data.shippingCOD.shippingType === 'automated' : data.shippingType === 'automated') &&
                parseInt(payload.deliveryPrice) +
                  parseInt( payload.payment === 'COD' ? data.shippingCOD.hideAdditionalCost ? data.shippingCOD.additionalCost : 0 : data.additionalCost) >
                  0
              "
              class="pp-order-summary__list__item"
              style="border-bottom-style: solid;"
            >
              <div>{{ $t('common.shippingCosts') }} ({{ weight | gramsToKilograms_format}}kg)</div>
              <div v-if="payload.deliveryPrice">
                Rp{{
                  (parseInt(payload.deliveryPrice) + (payload.payment === 'COD' ? (data.shippingCOD.hideAdditionalCost ? parseInt(data.shippingCOD.additionalCost) : 0) : (data.hideAdditionalCost ? parseInt(data.additionalCost) : 0)) || 0)
                  | g_number_format
                }}
              </div>
              <div v-else>
                {{ parseInt(0) | g_number_format }}
              </div>
            </div>
            <div v-if="
            (payload.payment === 'COD' ? data.shippingCOD.shippingType === 'automated' : data.shippingType === 'automated') &&
            data.addShipping && (payload.payment === 'COD' ? data.shippingCOD.shippingDiscount : data.shippingDiscount) &&
            (payload.payment === 'COD' ? data.shippingCOD.shippingDiscount.status : data.shippingDiscount.status) &&
                  parseInt(shippingDiscountValue) >
                  0
                  " class="pp-order-summary__list__item" style="border-bottom-style: solid;">
            <div>Diskon Pengiriman</div>
            <div>
              -Rp{{
                parseInt(shippingDiscountValue)
                | g_number_format
              }}
            </div>
          </div>

            <!-- ADDTIONAL SHIPPING COST -->
            <div
              class="pp-order-summary__list__item"
              style="border-bottom-style: solid;"
              v-if="
                (payload.payment === 'COD' ? !data.shippingCOD.hideAdditionalCost : !data.hideAdditionalCost) &&
                data.addShipping &&
                (payload.payment === 'COD' ? data.shippingCOD.additionalCost : data.additionalCost) &&
                parseInt(payload.payment === 'COD' ? data.shippingCOD.additionalCost : data.additionalCost) != 0
              "
            >
              <div>{{ $t('common.additionalShippingCost') }}</div>
              <div>Rp{{ parseInt(payload.payment === 'COD' ? data.shippingCOD.additionalCost : data.additionalCost) | g_number_format }}</div>
            </div>

            <!-- SHIPPING COST FLAT -->
            <div
              v-if="
                data.addShipping &&
                (payload.payment === 'COD' ? data.shippingCOD.shippingType === 'flat' : data.shippingType === 'flat')
              "
              class="pp-order-summary__list__item"
              style="border-bottom-style: solid;"
            >
              <div>{{ $t('common.shippingCosts') }}</div>
              <div>
                Rp{{
                  (parseInt((payload.payment === 'COD' ? data.shippingCOD.flatShippingPrice : data.flatShippingPrice) || 0) +
                    ((payload.payment === 'COD' ? data.shippingCOD.hideAdditionalCost : data.hideAdditionalCost)
                      ? parseInt((payload.payment === 'COD' ? data.shippingCOD.additionalCost : data.additionalCost) || 0)
                      : 0))
                    | g_number_format
                }}
              </div>
            </div>

            

            <!-- COD COST -->
            <div
              v-if="payload.payment == 'COD'"
              class="pp-order-summary__list__item flex justify-between"
              style="border-bottom-style: solid;"
            >
              <div>{{ $t('common.codFee') }}</div>
              <div>Rp{{ codPrice | g_number_format }}</div>
            </div>

            <!-- EPAY FEE -->
            <div
              v-if="
                this.payload.payment &&
                this.payload.payment != 'bankTransfer' &&
                this.payload.payment != 'COD' &&
                data.ePaymentFeePaidBy === 'buyer'
              "
              class="pp-order-summary__list__item flex justify-between"
              style="border-bottom-style: solid;"
            >
              <div>
                {{ paymentFeeMethodName(this.payload.payment) }}
                <p class="m-0 e-payment-admin-fee" v-if="this.payload.payment === 'gopay'">{{ $t('settings.adminEPayFeeGopay') }}</p>
                <p class="m-0 e-payment-admin-fee" v-else-if="this.payload.payment === 'QRIS'">{{ $t('settings.adminEPayFeeQRIS') }}</p>
                <p class="m-0 e-payment-admin-fee" v-else-if="this.payload.payment === 'credit_card'">{{ $t('settings.adminEPayFeeCreditCard') }}</p>
                <p class="m-0 e-payment-admin-fee" v-else>{{ $t('settings.adminEPayFeeOther') }}</p>
              </div>
              <div>Rp{{ this.payload.ePayFee || 0 | g_number_format }}</div>
            </div>

            <!-- <div v-if="totalBumpOrderPrice && data.isBump" class="flex justify-between">
                  <div>Bump Price</div>
                  <div>Rp{{ totalBumpOrderPrice | g_number_format }}</div>
                </div> -->

            <!-- UNIQUE PRICE -->
            <div
              v-if="payload.uniquePrice && payload.payment == 'bankTransfer'"
              class="pp-order-summary__list__item"
              style="border-bottom-style: solid;"
            >
              <div>{{ $t('common.uniquePrice') }}</div>
              <div>
                Rp {{ this.payload.uniqueType == "Decrease" ? "-" : "" }}
                {{ payload.uniquePrice }}
              </div>
            </div>
            <!-- COUPON -->                  
            <div v-for="(discount, index) in payload.discounts" :key="index" class="pp-order-summary__list__item flex justify-between align-items-center" style="border-bottom-style: solid; word-break: break-word;">
              <div class="w-50">{{discount.code}}</div>         
          
              <div class="w-50 text-right">-Rp{{ discount.amount | g_number_format }}</div>
            </div>
            <div v-if="data.showCoupon && payload.automaticDiscount.code" class="pp-order-summary__list__item flex justify-between align-items-center" style="border-bottom-style: solid; word-break: break-word;">
              <div class="w-50">{{payload.automaticDiscount.code}}</div>        
          
              <div class="w-50 text-right">-Rp{{ payload.automaticDiscount.amount | g_number_format }}</div>
            </div>
            <!-- VAT (PPN) -->
            <div v-if="data.VAT.isVAT && data.VAT.VATpercentage > 0" class="vat-price flex justify-between align-items-center">
              <div>PPN {{ data.VAT.VATpercentage }}%</div>
              <div>Rp{{ Math.round(VATPrice) | g_number_format }}</div>
            </div>
          </div>
          <!-- END ORDER SUMMARY LIST -->

          <!-- TOTAL -->
          <div class="pp-order-summary__total" style="border-top-style: solid;">
            <p class="pp-order-summary__total__label">{{ $t('common.total') }}</p>
            <p class="pp-order-summary__total__number">
              <template v-if="data.multiplyVariations">
                <template
                  v-if="
                    this.payload.payment &&
                    this.payload.payment != 'bankTransfer' &&
                    this.payload.payment != 'COD'
                  "
                >
                  Rp{{ totalPrice | g_number_format }}
                </template>
                <template v-else>
                  Rp{{
                    (cartSummary.length > 0 && cartTotalPrice
                      ? Math.round(cartTotalPrice + (data.VAT && data.VAT.isVAT ? (cartTotalPrice * data.VAT.VATpercentage)/100 : 0 ))
                      : totalPrice) | g_number_format
                    }}
                </template>
              </template>
              <template v-else>
                <template
                  v-if="
                    this.payload.payment &&
                    this.payload.payment != 'bankTransfer' &&
                    this.payload.payment != 'COD'
                  "
                >
                  Rp{{ totalPrice | g_number_format }}
                </template>
                <template v-else>Rp{{ totalPrice | g_number_format }}</template>
              </template>
            </p>
          </div>
          <!-- OLD CODE -->
          <!-- <div class="common-font order-summary-header mb-2">
            RINCIAN PESANAN:
          </div>
          <div
            class="flex justify-between mb-2"
            v-if="!cartSummary || cartSummary.length == 0"
          >
            <div class="common-font product-name product-title-shrink-checkout">
              {{ data.name }} ({{
                data.addQuantity && quantity ? quantity : noProductOptionQty
              }}x)
            </div>
            <div
              v-if="
                !data.multiplyVariations ||
                data.type == 'simple' ||
                (data.multiplyVariations && data.cartOrder)
              "
              class="text-right justify-between"
            >
              <div class="common-font regular_price">
                Rp{{ price | g_number_format }}
              </div>
              <div
                class="common-font sale_price text-danger right"
                style="text-decoration: line-through"
                v-if="data.priceCompare && data.type == 'simple'"
              >
                Rp{{
                  ((noProductOptionQty ? noProductOptionQty : quantity) *
                    data.price)
                    | g_number_format
                }}
              </div>
              <div
                v-else-if="parseInt(priceWithoutWhosale) !== parseInt(price)"
                class="text-danger def common-font sale_price"
                style="text-decoration: line-through"
              >
                Rp{{ priceWithoutWhosale }}
              </div>
            </div>
          </div>
          <div
            v-if="
              data.shippingType == 'automated' &&
              parseInt(payload.deliveryPrice) + parseInt(data.additionalCost) >
                0
            "
            class="flex justify-between right automated"
            :class="
              data.shippingType == 'automated' && payload.deliveryPrice
                ? 'mt-15'
                : ''
            "
          >
            <div>Biaya Pengiriman ({{ weight }}gr)</div>
            <div>
              Rp{{
                (parseInt(payload.deliveryPrice) +
                  parseInt(data.additionalCost))
                  | g_number_format
              }}
            </div>
          </div>
          <div
            v-if="
              data.shippingType == 'flat' &&
              parseInt(data.flatShippingPrice ? data.flatShippingPrice : 0) +
                parseInt(data.additionalCost) >
                0
            "
            class="flex justify-between"
            :class="data.shippingType == 'flat' ? 'mt-15' : ''"
          >
            <div>Biaya Pengiriman</div>
            <div>
              Rp{{
                (parseInt(data.flatShippingPrice ? data.flatShippingPrice : 0) +
                  parseInt(data.additionalCost))
                  | g_number_format
              }}
            </div>
          </div>
          <div
            v-if="payload.payment == 'COD'"
            class="flex justify-between"
            :class="payload.payment == 'COD' ? 'mt-15' : ''"
          >
            <div>Biaya COD</div>
            <div>Rp{{ codPrice | g_number_format }}</div>
          </div>
          <div
            v-if="data.type != 'simple'"
            :class="data.type != 'simple' ? 'mt-15' : ''"
          >
            <template
              v-if="
                !data.multiplyVariations ||
                data.type == 'simple' ||
                (data.multiplyVariations && data.cartOrder)
              "
            >
              <template
                v-if="
                  cartSummary &&
                  cartSummary.length > 0 &&
                  data.multiplyVariations
                "
              >
                <template v-for="(elem, i) in cartSummary">
                  <div
                    v-if="elem.qty && cartSummary[i]"
                    v-bind:key="i"
                    class="order-summary-list"
                  >
                    <div class="flex justify-between">
                      <div class="flex justify-start">
                        <div style="padding-right: 3px">({{ elem.qty }}x)</div>
                        <div class="single-variant">
                          <div
                            :key="l + 'p'"
                            v-for="(vprice, l) in Object.keys(elem.items)"
                          >
                            {{ vprice.substring(0, vprice.length - 1) }}:
                            {{ elem.items[vprice].name }}
                          </div>
                        </div>
                      </div>
                      <div style="text-align: end">
                        <div v-bind:key="i">
                          Rp {{ (elem.price * elem.qty) | g_number_format }}
                        </div>
                      </div>
                    </div>
                    <div
                      v-if="elem.qty > 0"
                      class="delete-variant text-right mt-10"
                      @click="removeFromCart(i)"
                    >
                      <img src="@/assets/icons/Delete-grey.svg" alt="" />
                    </div>
                  </div>
                </template>
              </template>
              <div v-else class="flex justify-between">
                <div class="flex justify-start">
                  <div style="padding-right: 3px">
                    ({{ quantity > 1 ? quantity : noProductOptionQty }}x)
                  </div>
                  <div class="single-variant right">
                    <div
                      :key="l + 'p'"
                      v-for="(vprice, l) in Object.keys(payload.variablePrices)"
                    >
                      <div>
                        {{ vprice.substring(0, vprice.length - 1) }}:
                        {{ payload.variablePrices[vprice].name }}
                      </div>
                    </div>
                  </div>
                </div>
                <div>Rp{{ price | g_number_format }}</div>
              </div>
            </template>
            <div v-else>
              <template>
                <div
                  v-bind:key="i"
                  v-for="(attr, i) in data.variablePrices"
                  :style="
                    attr.qty > 0
                      ? 'padding-bottom: 4px; border-bottom: 1px dashed #ccc; padding-top: 7px'
                      : ''
                  "
                >
                  <div
                    v-if="attr.qty > 0"
                    :key="'f' + i"
                    class="flex justify-between mb-1"
                  >
                    <div class="w-50">
                      ({{ attr.qty }}x)
                      {{
                        attr.attrs
                          .map(
                            (n) =>
                              n.name.substring(0, n.name.length - 1) +
                              ": " +
                              n.value
                          )
                          .join(",")
                      }}
                    </div>
                    <div class="text-right w-50 ct-3">
                      <div
                        class="text-danger"
                        style="text-decoration: line-through"
                        v-if="getSubPrice(attr) !== attr.price * attr.qty"
                      >
                        Rp{{ (attr.price * attr.qty) | g_number_format }}
                      </div>
                      <div>Rp{{ getSubPrice(attr) | g_number_format }}</div>
                    </div>
                  </div>
                  <div
                    v-if="attr.qty > 0"
                    class="delete-variant text-right"
                    @click="deleteVariant(i)"
                  >
                    <img src="@/assets/icons/Delete-grey.svg" alt="" />
                  </div>
                </div>
              </template>
            </div>
          </div>
          <div
            v-if="payload.bump"
            class="flex justify-between"
            :class="payload.bump ? 'mt-15' : ''"
          >
            <div>{{ data.bumpName }}</div>
            <div>Rp{{ data.bumpPrice | g_number_format }}</div>
          </div>
          <hr class="mt-15" />
          <div
            v-if="payload.uniquePrice && payload.payment == 'bankTransfer'"
            class="flex justify-between"
          >
            <div>Unique Price</div>
            <div>
              Rp {{ this.payload.uniqueType == "Decrease" ? "-" : "" }}
              {{ payload.uniquePrice }}
            </div>
          </div>
          <div class="flex justify-between font-bold mt-15">
            <div class="common-font total title">Total</div>
            <div v-if="data.cartOrder" class="common-font total price">
              Rp{{
                (cartSummary.length > 0 ? cartTotalPrice : totalPrice)
                  | g_number_format
              }}
            </div>
            <div v-else>
              <div class="common-font total price">
                Rp{{ totalPrice | g_number_format }}
              </div>
            </div>
          </div> -->
        </div>
      </template>
     </no-ssr>
    </div>
   
    <!-- BUY BUTTON-->
    <template v-if="displayDiv(posName, 'buyButton')">
      <!--- CAPTCHA -->
      <div
        v-if="
          (data.themeType == 'Classic' ||
            (data.themeType != 'Classic' &&
              data.templateType != 'RightSidebar') ||
            (data.themeType != 'Classic' &&
              data.templateType == 'RightSidebar' &&
              !isSizeWindow)) &&
          showCaptcha
        "
        class="checkout-content--right__feature embed-checkout-right-button embed-buyButton flex align-items-center grid-gap15px justify-center"
      >
        <vue-hcaptcha
          :sitekey="googleCaptchaKey"
          @verify="verifyCaptcha"
          @expired="expiredMethod"
          @challenge-expired="expiredMethod"
        ></vue-hcaptcha>
      </div>

      <div v-if="data.summaryPlacement == 'Before Buy Button'">
        <div
          class="checkout-content--right__feature embed-checkout-right-button embed-buyButton flex align-items-center grid-gap15px"
          v-if="
            data.themeType == 'Classic' ||
            (data.themeType != 'Classic' &&
              data.templateType != 'RightSidebar') ||
            (data.themeType != 'Classic' &&
              data.templateType == 'RightSidebar' &&
              !isSizeWindow)
          "
        >
          <div
            v-if="isSizeWindow && cartSummary.length && data.cartOrder"
            style="
              flex: 0 0 56px;
              width: 56px;
              background: #ffffff;
              border: 1px solid #bfcee0;
              border-radius: 8px;
              max-height: 56px;
              height: 100%;
              padding: 17px;
            "
            @click="openCartSummary()"
          >
            <div
              class="flex justify-content-center align-items-center position-relative"
            >
              <div class="cart-counter">
                {{ cartSummary ? cartSummary.length : 0 }}
              </div>
              <img src="@/assets/icons/Cart-bucket.svg" alt="" />
            </div>
          </div>

          <div
            :style="
              isSizeWindow && cartSummary.length && data.cartOrder
                ? 'flex: 0 0 calc(100% - 70px); width: calc(100% - 70px);'
                : 'flex: 0 0 100%; width: 100%;'
            "
          >
          <div v-if="(loadingPrice && data.variablePrices && data.enableProductOptions && data.variablePrices.length>0 && !isVariableItemSelected)" class="alert-warning1 mb-20 title-font error align-items-start d-flex"><img
                            class="mr-10"
                            src="@/assets/icons/error.svg"
                          />Kombinasi variasi ini tidak tersedia</div> 
            <div
              v-if="isDisabled"
              style="
                border-radius: 5px;
                background-color: #e0e0e0;
                min-height: 55px;
              "
              class="buy-button w-100 px-2 py-1 text-white text-center"
              :data-size="buyButton.buyButtonFontSize || 'Medium'"
            >
              <span
                style="color: rgba(0, 0, 0, 0.26); min-height: 55px"
                class="flex items-center justify-center"
                :class="{
                  'bold-buy-btn': buyButton.boldBuyButtonText,
                  'small-buy-btn': buyButton.buyButtonFontSize == 'Small',
                  'medium-buy-btn': buyButton.buyButtonFontSize == 'Medium',
                  'large-buy-btn': buyButton.buyButtonFontSize == 'Large',
                  'extra-large-buy-btn':
                    buyButton.buyButtonFontSize == 'Extra-Large',
                }"
              >
                {{ $t('common.stockEmpty') }}
              </span>
            </div>

            <div
              v-else-if="showCaptcha && !verifiedCaptcha"
              style="
                border-radius: 5px;
                background-color: #e0e0e0;
                min-height: 55px;
                justify-content: center;
              "
              class="buy-button w-100 px-2 py-1 text-white text-center flex items-center"
              :data-size="buyButton.buyButtonFontSize || 'Medium'"
            >
              <span
                style="color: rgba(0, 0, 0, 0.26)"
                class="flex items-center justify-center"
                :class="{
                  'bold-buy-btn': buyButton.boldBuyButtonText,
                  'small-buy-btn': buyButton.buyButtonFontSize == 'Small',
                  'medium-buy-btn': buyButton.buyButtonFontSize == 'Medium',
                  'large-buy-btn': buyButton.buyButtonFontSize == 'Large',
                  'extra-large-buy-btn':
                    buyButton.buyButtonFontSize == 'Extra-Large',
                }"
              >
                {{ buyButton.buyButtonText }}
              </span>
            </div>

            

            <!-- for show floating button  -->
            <button
              v-else-if="isSizeWindow && data.floatingButton"
              @click="() => !loadingPrice && save()"
              class="flex justify-center items-center pointer text-white m_float_btn"
              style="min-height: 55px; border-radius: 8px"
              :style="
                'background-color: ' +
                buyButton.buyButtonStyle +
                ';border: 1px solid ' +
                buyButton.buyButtonStyle +
                (isBuyButtonLoading | loadingPrice
                  ? '; opacity: 0.5; pointer-event: none; cursor: default;'
                  : '')
              "
            :disabled="isBuyButtonLoading || loadingPrice"
            >
              <div v-if="data.isAddIcon" class="d-flex justify-content-center">
                <img
                  v-if="isWhatsappIcon(buyButton.selectedIconName)"
                  src="@/assets/icons/whatsapp-link.svg"
                  alt="WhatsApp"
                  width="24"
                  height="24"
                />
                <vue-feather v-else :type="buyButton.selectedIconName"></vue-feather>
              </div>
              <div v-else class="d-flex justify-content-center">
                <i  data-v-07452373="" data-v-62b2fe6e="" data-name="shopping-cart" data-tags="ecommerce,cart,purchase,store" data-type="shopping-cart" class="feather feather--shopping-cart d-flex"><svg data-v-07452373="" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-shopping-cart feather__content"><circle cx="9" cy="21" r="1"></circle><circle cx="20" cy="21" r="1"></circle><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path></svg></i>
              </div>
            </button>

            <button
              v-else
              @click="() => !loadingPrice && save()"
              class="buy-button buy-button__default"
              :class="[
                buyButton.isAddIcon ? 'buy-button__default--show-icon' : '',
                isBuyButtonLoading ? 'buy-button__default--loading' : '',
                (data.variablePrices.length>0 && !isVariableItemSelected) ? 'buy-button__default--disabled' :''
              ]"
              :style="
                'background-color: ' +
                buyButton.buyButtonStyle +
                ';' +
                'border: 1px solid ' +
                buyButton.buyButtonStyle
              "
              :disabled="isBuyButtonLoading || loadingPrice || (data.variablePrices.length>0 && !isVariableItemSelected)"
              :data-size="buyButton.buyButtonFontSize || 'Medium'"
            >
              <div class="buy-button__default__ic-loading">
                <img src="@/assets/icons/ic-loading-button.svg" alt="loading" />
              </div>
              <span
                :class="{
                  'bold-buy-btn': buyButton.boldBuyButtonText,
                  'small-buy-btn': buyButton.buyButtonFontSize == 'Small',
                  'medium-buy-btn': buyButton.buyButtonFontSize == 'Medium',
                  'large-buy-btn': buyButton.buyButtonFontSize == 'Large',
                  'extra-large-buy-btn':
                    buyButton.buyButtonFontSize == 'Extra-Large',
                }"
              >
                {{ buyButton.buyButtonText }}
              </span>
              <template v-if="buyButton.isAddIcon">
                <img
                  v-if="isWhatsappIcon(buyButton.selectedIconName)"
                  src="@/assets/icons/whatsapp-link.svg"
                  alt="WhatsApp"
                  width="24"
                  height="24"
                />
                <vue-feather v-else :type="buyButton.selectedIconName"></vue-feather>
              </template>
            </button>
          </div>
        </div>
      </div>
    </template>

    <!-- DIGITAL PRODUCT LABEL -->
    <template v-if="displayDiv(posName, 'digitalProductLabel')">
      <div v-if="data.showDigitalProductLabel" id="digitalProductLabel">
        <DigitalProductLabel :payload="data" :isMobile="isMobile"/>
      </div>
    </template>
  </div>
</template>

<script>
import config from "./../../config.js";
import Left from "./left.vue";
import Seal from "./seal.vue";
// import FileUploader from "./../FileUploader.vue";
import SwitchGreenSelected from "./../SwitchGreenSelected.vue";
import AddressFill from "./../AddressFill.vue";
import SubAddress from "./../SubAddress.vue";
import ProvinceAddress from "./../addresses/ProvinceAddress.vue";
import CityAddress from "./../addresses/CityAddress.vue";
import DistrictAddress from "./../addresses/DistrictAddress.vue";
import SubDistrictAddress from "./../addresses/SubDistrictAddress.vue";
import { getSizedImageUrl } from "@/helpers/imagekitHelper";
// import Cookies from "js-cookie";
import { debounce, get, keys } from "lodash";
import axios from "axios";
import VueHcaptcha from "@hcaptcha/vue-hcaptcha";
import moment from "moment";
import { paymentFeeMethodName, calculateEpayFee } from "@/helpers/epayMethodHelper";
import { AUTOFILL_SOURCE, saveAutofillSource, toggleSaveDataChecked } from "@/helpers/checkoutAutofillHelper";
import Coupon from "./components/coupon.vue";
import DigitalProductLabel from "../DigitalProduct/DigitalProductLabel.vue";
import SelectedVariantChips from "./SelectedVariantChips.vue";
import Input from '@/components/Form/components/classic-form-input/input.vue';
import Textarea from '@/components/Form/components/classic-form-input/textarea.vue';
import InputFile from '@/components/Form/components/classic-form-input/input-file.vue';
import InputDate from '@/components/Form/components/classic-form-input/input-date.vue';
import Dropdown from "@/components/Form/components/classic-form-input/dropdown.vue";

export default {
  props: [
    "user",
    "codPrice",
    "data",
    "form",
    "weight",
    "loadingPrice",
    "isBuyButtonLoading",
    "payload",
    "submitted",
    "onChangeAction",
    "delivery",
    "templateType",
    "themeType",
    "price",
    "totalPrice",
    "priceWithoutWhosale",
    "isSizeWindow",
    "cartQuantity",
    "modalVariantOpen",
    "cartSummary",
    "embed",
    "popup",
    "noProductOptionQty",
    "cartTotal",
    "showCaptcha",
    "isMobile",
    "selectedbumpArray",
    "posName",
    "posIndex",
    "pos",
    "errors",
    "validate",
    "submited",
    "courierOptionDataFinal",
    "shippingDiscountValue",
    "filterAttributes",
    "isVariableItemSelected",
    "productImages",
    "variantImageIndex",
    "VATPrice",
    "discountLists",
    "totalQuantity",
    "allEstimatePublic"
  ],
  data() {
    return {
      moment,
      freeDeliveryPrice:'',
      baseUrl: config.api.replace("/api", ""),
      googleCaptchaKey: config.googleCaptchaKey,
      quantityOptions: [],
      verifiedCaptcha: false,
      buyButton: {},
      // cartSummary: [],
      isShowVariantImage: false,      
      deliveryCourierPrice: "",
      id: new Date().getTime(),
      showPaymentHideView: false,
      getSizedImageUrl,
      paymentFeeMethodName,
      calculateEpayFee,
      availablePaymentMethod: "all",
      screenMoreThan991px: true,
      selectedProvince: '',
      selectedCity: '',
      selectedDistrict: '',
      selectedSubDistrict: '',
      isAddressUnsupported: false,
      isAddressUnsupportedCod: false,
      isInitial: true
    };
  },
  created() {
    if (this.pos.id && this.pos.id > 1) {
      this.buyButton = this.data.buyButtonChild[this.pos.uniqueName];
    } else {
      this.buyButton = this.data;
    }
  },
  components: {
    Seal: Seal,
    AddressFill,
    SubAddress,
    // FileUploader: FileUploader,
    "selected-green-switch": SwitchGreenSelected,
    Left: Left,
    VueHcaptcha,
    Coupon,
    DigitalProductLabel,
    SelectedVariantChips,
    Input,
    InputFile,
    Textarea,
    InputDate,
    Dropdown,
    ProvinceAddress,
    CityAddress,
    DistrictAddress,
    SubDistrictAddress
  },
  computed: {
    compfieldsPositionMobile() {
      return this.mobileVersion
        ? this.data.fieldsPositionMobile
        : ["singledummy"];
    },
    quantity: {
      get() {
         if(this.data.type == 'simple'){
          const index=this.data.requestedFields.findIndex(x=>x.field=='quantity' && x.active);       
          if(index > -1){
            return this.data.requestedFields[index].value;
          }else{
            return this.cartQuantity;
          }
        }else{
          return this.cartQuantity;
        }   
       
      },
      set(val) {
        this.$emit("updateCartQuantity", val);
      },
    },
    cartTotalPrice: {
      get() {
        return this.cartTotal;
      },
      set(val) {
        this.$emit("updateCartTotal", val);
      },
    },
    isDisabled() {
      if (this.data.trackQuantity && !this.data.continueSelling) {
        if (this.data.type == "simple") {
          return this.data.available < this.payload.quantity;
        } else {
          let disabled = false;
          this.data.variablePrices.map((one) => {
            if (one.available < one.qty) {
              disabled = true;
            }
          });
          return disabled;
        }
      } else {
        return false;
      }
    },
    datas() {
      return this.data.requestedFields.map((one) => {
        return {
          [one.field]: one.value,
        };
      });
    },
    totalQtyMultipleVariant() {
      if (this.cartSummary && this.cartSummary.length > 0 && this.data.multiplyVariations) {
        return (this.cartSummary || []).reduce((accumulation, item) => {
          return (accumulation || 0) + (item.qty || 0)
        }, 0)
      }

      return (this.data.variablePrices || []).reduce((accumulation, item) => {
        return (accumulation || 0) + (item.qty || 0)
      }, 0)
    },
    preOrderText() {
      return this.$t('common.preOrder').replace(/x/g, this.data.preOrder.packagingDueDay);
    },
    isProductVariantSelected() {
      return this.data.variablePrices.some(item => item.qty > 0);
    },
    paymentType() {
      let paymentType = this.data.paymentType.filter((p) => p.active)

      if (this.availablePaymentMethod == "cod") {
        paymentType = this.data.paymentType.filter((p) => p.active && p.type == "COD")
      } else if (this.availablePaymentMethod == "nonCod") {
        paymentType = this.data.paymentType.filter((p) => p.active && (p.type == "bankTransfer" || p.type == "E-Payment"))
      }

      return paymentType
    },
    shippingHideView() {
      return this.payload.payment === 'COD' ? get(this.data, 'shippingCOD.shippingHideView', false) : get(this.data, 'shippingHideView', false);
    }
  },
  methods: {
    isWhatsappIcon(iconName) {
      return iconName === "whatsapp";
    },
    getSelectedAddressValue(key) {
      if (!key) return null;

      if (key === 'ENTER_CITY_NAME') return this.payload.address.CITY;

      const mapKey = key.split("_")[0]; //PROVINCE_NAME → PROVINCE

      switch (mapKey) {
        case 'PROVINCE':
          return this.selectedProvince;
        case 'CITY':
          return this.selectedCity;
        case 'DISTRICT':
          return this.selectedDistrict;
        case 'SUBDISTRICT':
          return this.selectedSubDistrict;
        default:
          return null;
      }
    },
    formatPhone() {
      let phoneDataIndex = this.data.requestedFields.findIndex(
          (x) => x.field ==='phone'
        );
        if(phoneDataIndex && phoneDataIndex > -1){
          this.data.requestedFields[phoneDataIndex].value=this.data.requestedFields[phoneDataIndex].value.replaceAll('-', '').replaceAll('.', '')
        }
      
    },
    getValidationRules(requestedField) {
      // validation references -> embed-form/plugins/vee-validate.js
      let rules = ['']
      if (requestedField.required === 'yes') {
        rules.push('required')
      }
      if (requestedField.field === 'phone') {
        rules.push('phone_number')
      }
      if (requestedField.field === 'email' || requestedField.inputType == "email") {
        rules.push('email')
      }
      if (requestedField.inputType == "url") {
        rules.push('url')
      }
      
      return rules.join('|');
    },
    loadShippingImage(src) {
      return require('@/assets' + src);
    },
    loadEstimateDelivery(item) {
      const courierName = item && item.label ? 
                            item.label.includes('-') ? 
                              item.label.split('-')[0].trim() : 
                              item.label.trim() : 
                          item;
      const courierParsed= (courierName.toLowerCase() == 'sicepat') ? 'SiCepat' : (courierName== 'jNt' || courierName== 'J&T') ? 'JT' : (courierName== 'jne') ? 'JNE' : (courierName== 'sap') ? 'SAP'  : (courierName== 'ninja' || courierName== 'Ninja Xpress') ? 'Ninja' : (courierName== 'Lion Parcel') ? 'lion' : (courierName.toLowerCase() == 'spx express') ? 'spx' : courierName; 

      let delivery = this.allEstimatePublic[courierParsed]
                    ? (this.allEstimatePublic[courierParsed].estimate_delivery && this.allEstimatePublic[courierParsed].estimate_delivery !== "-"
                        ? this.allEstimatePublic[courierParsed].estimate_delivery
                        : "Not available")
                    : "Not available";

      if (typeof delivery === "string") {
        const matched = delivery.match(/[\d]+ *- *[\d]+/);
        delivery = matched ? matched[0].replace(/\s+/g, "") : delivery;
      }

      this.isInitial = false
      
      return {
        days: delivery || "-",
        unsupported: !this.data.isShippingCoverageCheckEnabled ? false :
          this.allEstimatePublic[courierParsed] ? this.allEstimatePublic[courierParsed].unsupported || false : false,
        unsupportedCod: !this.data.isShippingCoverageCheckEnabled ? false : 
          this.allEstimatePublic[courierParsed] ? this.allEstimatePublic[courierParsed].unsupported_cod || false : false
      }
    },
    showSelectedLabel(value) {
      const selected = this.courierOptionDataFinal.find(opt => opt.value === value)
      if (this.isAddressUnsupported) {
        selected.label = selected.label.replace(selected.label.split('-')[2], ` ${this.$t('common.unreachableAddress')}`)
      }
      return selected && selected.label ? selected.label : ''
    },
    isCheapest(label, optionsData) {
      const filteredOptions = optionsData.filter(option => {
        const courierParsed= (option.key == 'siCepat') ? 'SiCepat' : (option.key== 'jNt') ? 'JT' : (option.key== 'jne') ? 'JNE' : (option.key== 'sap') ? 'SAP'  : (option.key== 'ninja') ? 'Ninja' : (option.key== 'iDexpress') ? 'iDexpress' : option.key; 
        const courierEstimate = this.allEstimatePublic[courierParsed];

        if (!courierEstimate) return true;

        const isUnsupported = courierEstimate.unsupported === true;
        return !isUnsupported;
      });

      const prices = filteredOptions.map(option => parseInt(option.label.split('-')[2].replace('Rp', '').replace(',', '')));

      const currentPrice = parseInt(label.split('-')[2].replace('Rp', '').replace(',', ''));
      return Math.min(...prices) == currentPrice;
    },
    checkdisabled(discount) {   
      let discount_amount=0;          
      let totalQuantity=this.totalQuantity;
      let price =  this.price;  
      if(this.cartSummary.length > 0){
          totalQuantity=0;
          price = 0;
          this.cartSummary.map(async (e) => {
            if (!e) return;
            totalQuantity = totalQuantity + e.qty;
            let subPrice = (e.price ? e.price : e.priceOriginal) * e.qty;
              if (e.whosaleData) {
                e.whosaleData.map((one) => {
                  if (one.count && parseInt(one.count) <= parseInt(e.qty)) {
                    subPrice = one.price * parseInt(e.qty);
                  }               
                });
              }             
              price = price + subPrice;     
           
        });
      }     
    
     if(discount.minimum_requirements.type=='minimum_purchase'){         
        if(Number(discount.minimum_requirements.value)>this.totalPrice){
          return discount_amount > 0 
        }        
      }else if(discount.minimum_requirements.type=='minimum_quantity'){       
        if(Number(discount.minimum_requirements.value)>totalQuantity){
          return discount_amount > 0 
        }        
      } 
      if(discount.discount_type=="moneyOffProduct"){
      
          if(discount.discount_value.type=="fixed"){                   
            discount_amount=(Number(discount.discount_value.value));           
          }else{
            discount_amount =(price *Number(discount.discount_value.value)) / 100;                                       
                           
          }       
          
        }else if(discount.discount_type=="moneyOffOrder"){
          if(discount.discount_value.type=="fixed"){                   
            discount_amount=Number(discount.discount_value.value);         
          }else{
            discount_amount =(this.totalPrice *Number(discount.discount_value.value)) / 100;                             
                    
          }  
        }else if(discount.discount_type=="moneyOffShipping"){
          if (this.payload.deliveryPrice) {
            if (discount.discount_value.applies_to.shipping_type=='all' || discount.discount_value.applies_to.shipping_type==this.payload.deliveryCourier) {
              if (discount.discount_value.type=="fixed"){                   
                discount_amount=Number(discount.discount_value.value);         
              } else{
                discount_amount =(this.payload.deliveryPrice *Number(discount.discount_value.value)) / 100;    
              }

              return discount_amount > 0    
            }
          }

          return true;
        }     
       
        return discount_amount > 0        
    },
    updateDiscountLists(discounts,replace){
      this.$emit('updateDiscountLists',discounts,replace)
    },
    selectDiscount(discount) {
      this.$emit('applyDiscount', discount.title)
    },
    clearDiscountCode(code) {     
      //e.stopPropagation()
      this.calcCart();
      // this.$emit('applyDiscount', '')
      this.$emit('clearDiscount', code)
      
    },
    getImageSrc(attr){ 
      let imageUrl;     
      const variantImageIndex = this.data.variablePrices && this.data.variablePrices.findIndex(
          (x) => x.name  && x.image && x.name.indexOf(attr.attrs[0].value+" / ") > -1
        );     
      if(attr.image){       
        imageUrl= getSizedImageUrl(attr.image,'medium','product-images')
      } 
      else if (variantImageIndex > -1 && this.data.variablePrices && this.data.variablePrices[variantImageIndex].image ){       
        imageUrl= getSizedImageUrl(this.data.variablePrices[variantImageIndex].image,'medium','product-images'); 
      } 
      else if (this.productImages.length>0 ){       
        imageUrl= getSizedImageUrl(this.productImages[0].src,'medium','product-images'); 
      } 
      else {       
        imageUrl= require('@/assets/icons/variant-default-img.svg')
      }       
      return imageUrl;
    },
    isHasOneWordLongText (text, maxLength=10){
      const words = text.split(' ');

      const result = words.some(word => {
          return word.length >= maxLength;
      });

      return result;
    },
    addBumpOrder(event,bumpData){      
      if(event.target.className!='vs-checkbox'){      
        const bumpIndex=this.selectedbumpArray.findIndex(x=>x.bump_id==bumpData.bump_id);
        if(bumpIndex==-1){
          this.selectedbumpArray.push(bumpData);
        }else{
          this.selectedbumpArray.splice(bumpIndex,1);
        }         
        event.preventDefault();      
     }
    },  
    truncatedText(text, getText = true) {
      const maxLength = 10;
      if (text.length > maxLength) {
        return getText ? text.slice(0, maxLength) + "..." : true;
      } else {
        return getText ? text + "..." : false;
      }
    },
    async estimate(){
      const orignalPrice = this.payload.payment === 'COD' ? this.data.shippingCOD.originalShippingCost : this.data.originalShippingCost;
      const reqUrl = `${this.baseUrl}api/tracking/allEstimatePublic`;

      let val = this.payload.address
      if(this.data && this.data.isShowStrikethrough && val && val.customerAUTOFILL){
        let weight = this.weight
        weight = weight / 1000
        if (weight < 1) {
          weight = 1
        }
        let shipFromAddress = this.data.multipleShipFrom && this.data.multipleShipFrom.length > 0 ? this.data.multipleShipFrom[0] : this.data.shipFrom
        let splitshipfrom = shipFromAddress.split('-');
        // let origin = splitshipfrom.length > 0 ? splitshipfrom[0] : shipFromAddress
        let origin_id = splitshipfrom.length > 2 ? splitshipfrom[splitshipfrom.length-1] : splitshipfrom[0];      
       if(this.data.multiShipFromAddress && this.data.multiShipFromAddress.length > 0 && this.data.multiShipFromAddress[origin_id] && this.data.multiShipFromAddress[origin_id].address){
        origin_id=this.data.multiShipFromAddress[origin_id].address.PICKUP_AUTOFILL
       }

        let destination_to = val.customerAUTOFILL
        const to= val.DESTINATION_CODE
        let res = await axios.get(reqUrl, { params: { username: this.user.username, origin_id: origin_id, destination_id: destination_to, to: to, weight: weight, courier: "jne", from: orignalPrice ? "origin" : undefined  } })
        if (res.data.success) {
          const firstCourier = keys(res.data.data)[0];
          this.freeDeliveryPrice =  get(res.data.data, [firstCourier, 'price'], "");
        } 
        this.$forceUpdate();
      } else {
        this.freeDeliveryPrice = ''
      }
    },
    checkOption(name,attrval){    
     return !this.filterAttributes[name+"_"+attrval]
    },
    calEpayFee() {
      return calculateEpayFee(this.payload.payment, this.data.ePaymentFeePaidBy || 'buyer', this.totalPrice);
    },
    changeCouriePrice() {
      let price = this.deliveryCourierPrice;
      if (price) {
        //for getting origin id for the seller address
        let sellerOriginId = null;
        this.courierOptionDataFinal.forEach(option => {
          if (option.value == price) {
            sellerOriginId = option.origin_id;
          }
        });
        price = price.split("==");
        let priceLabel = this.courierOptionDataFinal.find(
          (x) => x.value == this.deliveryCourierPrice
        );
        priceLabel = priceLabel.label.split("-");
        this.payload.sellerOriginId = sellerOriginId;
        this.payload.deliveryCourier = price[0];
        this.payload.deliveryPrice = price[1];
        this.payload.deliveryType = priceLabel[1].trim()
          ? priceLabel[1].trim()
          : "REG";
        this.$forceUpdate();
      }
    },
    deleteVariant(index) {
      if (this.data.variablePrices) {
        this.data.variablePrices[index].qty = 0;
      }
      this.$forceUpdate();
    },
    deleteBumpProduct(index) {
      this.selectedbumpArray.splice(index, 1)
    },
    displayCopyright(index) {
      if (this.isSizeWindow) {
        if (this.compfieldsPositionMobile.length - 1 == index) {
          return true;
        } else {
          return false;
        }
      }
      return true;
    },
    displayDiv(fieldName, divName) {
      if (this.isSizeWindow) {
        if (fieldName == divName) {
          return true;
        } else {
          return false;
        }
      } else {
        return true;
      }
    },
    changeText() {
      var text3 = document.getElementsByClassName("bumpText3");
      if (text3.length) {
        text3[0].removeAttribute("disabled");
      }
    },
    async verifyCaptcha(data) {
      let res = await axios.post(config.api + "auth/verifyGoogleCaptcha", {
        response: data,
      });
      if (res.data.data.success) {
        this.verifiedCaptcha = true;
      }
    },
    expiredMethod() {
      this.verifiedCaptcha = false;
    },
    calcCart() {
      const isPaymentCOD = this.payload.payment === 'COD';
      const shippingType = isPaymentCOD ? this.data.shippingCOD.shippingType : this.data.shippingType;
      const additionalCost = isPaymentCOD ? this.data.shippingCOD.additionalCost : this.data.additionalCost;
      const flatShippingPrice = isPaymentCOD ? this.data.shippingCOD.flatShippingPrice : this.data.flatShippingPrice;
      
      let price =
        0 +
        parseFloat(this.payload.deliveryPrice ? this.payload.deliveryPrice : 0);
      const wholesaleQty = this.data.multiplyVariations && this.data.cartOrder
        ? this.cartSummary.reduce((total, item) => total + parseInt(item.qty || 0), 0)
        : 0;
      this.cartSummary.map(async (e) => {
        if (!e) return;
        let subPrice = (e.price ? e.price : e.priceOriginal) * e.qty;
        if (e.whosaleData) {
          e.whosaleData.map((one) => {
            const qtyForWholesale = wholesaleQty || parseInt(e.qty);
            if (one.count && parseInt(one.count) <= qtyForWholesale) {
              subPrice = one.price * parseInt(e.qty);
            }
            // return subPrice
          });
        }
        price = price + subPrice;
      });

      if (isPaymentCOD) {
        price = price + parseFloat(this.codPrice);
      }
      if (this.payload.uniquePrice && this.payload.payment == "bankTransfer") {
        price =
          price +
          (this.data.codeType == "Decrease"
            ? -this.payload.uniquePrice
            : this.payload.uniquePrice);
      }
      if (additionalCost && this.data.addShipping) {
        price = price + parseInt(additionalCost);
      }
      if (flatShippingPrice && shippingType == "flat") {
        price = price + parseInt(flatShippingPrice);
      }
      if (this.shippingDiscountValue && this.data.addShipping && shippingType == "automated" && this.shippingDiscountValue > 0) {
        price = price - parseFloat(parseFloat(this.shippingDiscountValue));
      }

      if (
        this.data.isBump &&
        this.data.bumpArray &&
        this.data.bumpArray.length >= 0 &&
        this.selectedbumpArray
      ) {
        // price = price + parseFloat(this.data.bumpPrice)
        this.selectedbumpArray.map((bumpData) => {
          //  const bumpData = this.data.bumpArray.find((data) => data.bump_id == bump_id)
          if (bumpData) {
            price =
              price + (bumpData.bumpPrice ? parseFloat(bumpData.bumpPrice) : 0);
          }
        });
      }
      if (typeof price == "string") {
        price = parseFloat(price);
      }
      // return parseInt(price.toFixed())
      this.$emit("updateTotalOriginal",price);     
      for (const discount of this.payload.discounts) {
        if (discount.amount > 0){
          price -= discount.amount;
        }    
      }
      if(this.payload.automaticDiscount["amount"] > 0){
        price = price-this.payload.automaticDiscount["amount"]
      }   
      this.cartTotalPrice = parseInt(price.toFixed());
    },
    changeMode(param) {
      this.payload.paymentMode = param;
    },
    handlePaymentSelection(payment, paymentMode, disabled = false) {
      if (disabled) return;

      this.payload.payment = payment;
      this.changeMode(paymentMode);
      this.$set(this.payload, '_paymentSelectedByBuyer', true);
    },
    addToCart() {
      this.$emit("addToCart");
      setTimeout(() => {
        this.calcCart();
      }, 1000);
    },
    openCartSummary() {
      this.$emit("cartOrderSummary");
    },
    getSubPrice(attr) {
      let price = 0;
      if (attr.qty) {
        let subPrice = attr.priceCompare
          ? attr.priceCompare
          : attr.price
            ? attr.price
            : attr.priceOriginal;
        if (attr.whosaleData) {
          const wholesaleQty = this.data.multiplyVariations && this.data.cartOrder && this.cartSummary && this.cartSummary.length
            ? this.cartSummary.reduce((total, item) => total + parseInt(item.qty || 0), 0)
            : parseInt(attr.qty);
          attr.whosaleData.map((one) => {
            if (one.count && parseInt(one.count) <= wholesaleQty) {
              subPrice = one.price;
            }
          });
        }
        price = price + subPrice * attr.qty;
      }
      return price;
    },
    changeAddress(val) {
      this.payload.address = val;
      this.$emit("onAddressChange", val);
    },
    isAddressFieldActive(key) {
      return this.data.requestedFields.some(field => field.active && field.field == 'address' && field.key == key)
    },
    isAddressFieldRequired(key) {
      return this.data.requestedFields.some(field => field.active && field.required == 'yes' && field.field == 'address' && field.key == key)
    },
    changeAddresses(val, from) {
      this.payload.address = val;

      if (from === 'province') {
        this.selectedCity = '';
        this.selectedDistrict = '';
        this.selectedSubDistrict = '';
        this.selectedProvince = val.PROVINCE;
      } else if(from === 'city') {
        this.selectedSubDistrict = '';
        this.selectedDistrict = '';
        this.selectedCity = val.CITY;
        this.selectedProvince = val.PROVINCE;
      } else if(from === 'district') {
        this.selectedSubDistrict = '';
        this.selectedProvince = val.PROVINCE;
        this.selectedCity = val.CITY;
        this.selectedDistrict = val.DISTRICT;
        this.selectedSubDistrict = ''
      } else if(from === 'subdistrict') {
        this.selectedProvince = val.PROVINCE;
        this.selectedCity = val.CITY;
        this.selectedDistrict = val.DISTRICT;
        this.selectedSubDistrict = `${val.SUBDISTRICT} - ${val.ZIP}`;
      }
      this.$emit("onAddressChange", val, from);
    },
    findLastIndex(array, searchKey, searchValue, label) {
      let revArr = array.slice().reverse();
      let gValue = revArr.findIndex((x) => {
        return x.label === label;
      });
      var index = revArr.findIndex((x, i) => {
        return x[searchKey] === searchValue && i > gValue;
      });
      var count = array.length - 1;
      var finalIndex = index >= 0 ? count - index : index;
      return finalIndex;
    },
    showFields(index) {
      if((this.data.nuxt2 && process.client) || !this.data.nuxt2){
      let checkLast =  this.data.requestedFields.findLastIndex((e) => e.active);
      checkLast = checkLast > -1 ? checkLast : 0;
      if (
        (this.data.requestedFields[checkLast].field != "address" &&
          (this.data.requestedFields[checkLast].value ||
            this.data.requestedFields[checkLast].value != "")) ||
        (this.data.requestedFields[checkLast].field == "address" &&
          ((this.data.requestedFields[checkLast].key == "ENTER_CITY_NAME" &&
            this.payload.address) ||
            (this.data.requestedFields[checkLast].key != "ENTER_CITY_NAME" &&
              this.payload.address &&
              this.data.requestedFields[checkLast] &&
              this.data.requestedFields[checkLast].key &&
              this.payload.address[
                this.data.requestedFields[checkLast].key.split("_")[0]
              ])))
      ) {
        this.enableSubmitButton = true;
      }
      if (this.data.formMode == "Progressive Form" && index != 0) {
        let initialindex = this.data.requestedFields.findIndex(
          (x) => x.label === this.data.initialFields
        );
        if (
          index <= initialindex &&
          this.data.requestedFields[initialindex].active === true
        ) {
          return true;
        }
        let currentIndex = index - 1;
        if (
          currentIndex > -1 &&
          !this.data.requestedFields[currentIndex].active
        ) {
          let lastIndex = this.findLastIndex(
            this.data.requestedFields,
            "active",
            true,
            this.data.requestedFields[index].label
          );
          currentIndex = lastIndex;
        }

        const field = this.data.requestedFields[currentIndex];
        if (
          field &&
          (
            (
              field.field !== "address" &&
              (!field.value || field.value === "")
            ) ||
            (
              field.field === "address" &&
              (
                !this.getSelectedAddressValue(field.key)
              )
            )
          )
        ) {
          return false;
        }
      }
    }
      return true;

    },
    save() {
      if (this.isAddressUnsupported || (this.isAddressUnsupportedCod && this.payload.payment == 'COD')) {
        this.$vs.notification({
          color: "danger",
          position: "top-right",
          text: "Pengiriman yang kamu pilih belum support COD & Non COD",
          duration: 3000,
        });
        return
      }
      if(this.data.saveInfoWithoutEnable && this.data.isSaveInfoNextTime){
        this.saveDataForNexttime()
      }
      this.$emit("onSubmitted", true);
    },   
    increment(val, type) {    
     
      if (type == "multiVariant") {
        if (this.data.variablePrices[val]) {
          this.data.variablePrices[val].qty =
            parseInt(this.data.variablePrices[val].qty) + 1;
        }
      } else if (type == "singleVariant") {
        this.quantity = this.quantity + 1;
      }
      this.$forceUpdate();
    },
    decrement(val, type) {
      if (type == "multiVariant") {
        if (
          this.data.variablePrices[val].qty &&
          this.data.variablePrices[val].qty > 0
        ) {
          if (this.data.variablePrices[val].qty < 1) {
            return;
          } else {
            let variantData = this.data.variablePrices[val];
            variantData.qty = variantData.qty - 1;
            this.data.variablePrices.splice(val, 1, variantData);
          }
        }
      } else if (type == "singleVariant") {
        if (this.quantity < 2) {
          return;
        } else {
          this.quantity = this.quantity - 1;
        }
      }
      this.$forceUpdate();
    },
    // The "save" checkbox saves right away, ticked or not, as before.
    onSaveDataCheckbox() {
      toggleSaveDataChecked();
      this.saveDataForNexttime();
    },
    saveDataForNexttime() {
      let subdomain = window.location.hostname;
      let customerInfoArr = {};
      let customerAddrArr = {};
      if (this.data.requestedFields && subdomain) {
        customerInfoArr[subdomain] = this.data.requestedFields;
        localStorage.setItem(
          "CheckoutCustomerInfo",
          JSON.stringify(customerInfoArr)
        );
      }
      if (this.payload.address != null) {
        customerAddrArr[subdomain] = this.payload.address;
        localStorage.setItem(
          "CheckoutAddressInfo",
          JSON.stringify(customerAddrArr)
        );
      }
      saveAutofillSource(subdomain, AUTOFILL_SOURCE.SAVE_DATA);
    },
    getSelectedVariantImage() {
      this.isShowVariantImage = false;
      if (this.data.attributes.length) {
        let d = this.data.attributes[0];
        this.data.attributes[0].image = [];
        let selectedVariant = Object.values(this.payload.variablePrices);
        selectedVariant.shift();
        selectedVariant = selectedVariant.map((data) => {
          return data.name;
        });
        d.value.forEach((ef) => {
          let getSelectedVariant =
            ef + " / " + selectedVariant.toString().replace(/[,]/g, " / ");
          if (this.data.variablePrices.length) {
            this.data.variablePrices.forEach((elem) => {
              if (!this.isShowVariantImage && elem.image !== undefined) {
                this.isShowVariantImage = true;
              }
              if (getSelectedVariant == elem.name) {
                let image =
                  elem.image !== undefined
                    ? getSizedImageUrl(elem.image,'medium','product-images')
                    : require("@/assets/icons/variant-default-img.svg");
                this.data.attributes[0].image.push(image);
              }
            });
          }
        });
        this.$forceUpdate();
      }
    },
    openChooseVariantModal() {
      this.$emit("showMobile", this.cartSummary);
    },
    updateQuantity() {
      let keys = Object.keys(this.payload.variablePrices);
      let selectedVariant = this.payload.variablePrices
        ? keys.map((o) => this.payload.variablePrices[o].name).join(" / ")
        : undefined;
      let f = this.data.variablePrices.filter((e) => e.name == selectedVariant);
      if (f.length) {

        if(!(this.data.multiplyVariations && !this.data.cartOrder)){
          f[0].qty = f[0].qty == 0 ? 1 : f[0].qty;
        }       
        this.quantity = f.length ? f[0].qty : this.quantity;
      }
      this.$forceUpdate();
    },
    removeFromCart(index) {
      if (this.cartSummary.length) {
        this.$emit("updateCartSummary", index);
      }
      this.calcCart();
    },
    checkShowPaymentHideView() {
      this.showPaymentHideView = false;
      let bankTransferStatus = false;
      let EpaymentStatus = false;
      let CODStatus = false;

      const bankTransfer = this.data && this.data.paymentType.filter(
        (p) => p.active && p.type == "bankTransfer"
      );
      const Epayment = this.data && this.data.paymentType.filter(
        (p) => p.active && p.type == "E-Payment"
      );
      const COD = this.data.paymentType.filter(
        (p) => p.active && p.type == "COD"
      );

      if (bankTransfer && bankTransfer.length > 0) {
        //bankTransferStatus=this.data.bankTransferSettings.filter((p) => p.active).length==1;
        bankTransferStatus = true;
      }
      if (Epayment && Epayment.length > 0) {
        EpaymentStatus =
          this.data.epaymentSettings.filter((p) => p.active).length == 1;
      }
      if (COD && COD.length > 0) {
        CODStatus = true;
      }
      if (
        this.data.paymentType &&
        this.data.paymentType.filter((p) => p.active).length == 1 &&
        (bankTransferStatus || EpaymentStatus || CODStatus) &&
        this.data.paymentHideView &&
        this.data.paymentType
      ) {
        this.showPaymentHideView = true;
      }
    },
    shouldDisplayProductVariantOnCheckout(name, attrValue) {
      return !this.data.hideUnavailableProductVariant || (this.data.hideUnavailableProductVariant && !this.checkOption(name, attrValue));
    },
    filteredProductVariant(attrValues, attrName) {
      return attrValues.filter(attrValue => this.shouldDisplayProductVariantOnCheckout(attrName, attrValue));
    },
    isProgressiveFormVariants() {
      if (this.isMobile && this.data.formMode === "Progressive Form" && this.data.hasProgressiveVariants) {
          return true;
      }

      return false;
    },
    isShowFieldsProductAttributes(index, attributes) {
      // Cek apakah form mode BUKAN Progressive Form
      if (!this.isProgressiveFormVariants()) {
        return true;
      }

      if (index === 0) {
        return true;
      }

      const prevIndex = index - 1;
      const prevAttr = attributes[prevIndex];
      const prevAttrName = prevAttr.name;

      // Ambil item sebelumnya di index sebelum current index
      const prevIndexValue = get(this.payload, `variablePrices.${prevAttrName}${prevIndex.toString()}.name`);

      // Jika ada nilai sebelumnya, tampilkan pilihan sampai index saat ini
      if (prevIndexValue === null) {
        return false;
      }

      // Jika tidak ada nilai sebelumnya, hanya tampilkan sampai index sebelum ini
      return true;
    },
    isAllVariantsSelectedValid() {
      if (!this.isProgressiveFormVariants()) {
        return true;
      }

      // Cek apakah semua varian yang dipilih valid
      const variablePrice =  get(this.payload, 'variablePrices');
      return Object.values(variablePrice).every(item => item && item.name !== null && item.name !== undefined && item.name !== '');
    },
    checkAvailablePaymentMethod(address) {
      this.data.excludeShippingLocation.forEach((item) => {
        if (item.type == "province") {
          if (address && address.PROVINCE && address.PROVINCE.toLowerCase() == item.PROVINCE_NAME.toLowerCase()) {
            this.availablePaymentMethod = item.paymentMethod;
          }
        } else if (item.type == "city") {
          if (address && address.CITY && address.CITY.toLowerCase() == item.CITY_NAME.toLowerCase()) {
            this.availablePaymentMethod = item.paymentMethod;
          }
        } else if (item.type == "district") {
          if (
              address &&
              address.PROVINCE &&
              address.PROVINCE.toLowerCase() == item.PROVINCE_NAME.toLowerCase() &&
              address.CITY &&
              address.CITY.toLowerCase() == item.CITY_NAME.toLowerCase() &&
              address.DISTRICT &&
              address.DISTRICT.toLowerCase() == item.DISTRICT_NAME.toLowerCase()
            )
          {
            this.availablePaymentMethod = item.paymentMethod;
          }
        }
      })
    },
    changeDefaultPayment(val) {
      this.payload.payment = val;
    },
    autoSelectPayment() {
      let paymentType = this.data.paymentType.filter((p) => p.active)

      if (this.availablePaymentMethod == "cod") {
        paymentType = this.data.paymentType.filter((p) => p.active && p.type == "COD")
      } else if (this.availablePaymentMethod == "nonCod") {
        paymentType = this.data.paymentType.filter((p) => p.active && (p.type == "bankTransfer" || p.type == "E-Payment"))
      }

      const buyerPaymentIsAvailable = this.payload._paymentSelectedByBuyer && (
        paymentType.some((paymentTypeOption) => paymentTypeOption.type === this.payload.payment) ||
        paymentType.some((paymentTypeOption) =>
          paymentTypeOption.type === 'E-Payment' && this.data.epaymentSettings.some((option) => option.active && option.id === this.payload.payment)
        )
      )
      if (buyerPaymentIsAvailable) return

      for (const paymentTypeOption of paymentType) {
        if (paymentTypeOption.type == "E-Payment") {
          const activeEPayment = this.data.epaymentSettings.find((payment) => payment.active)
          if (!activeEPayment) continue

          this.changeDefaultPayment(activeEPayment.id)
        } else {
          this.changeDefaultPayment(paymentTypeOption.type)
        }

        this.changeMode(paymentTypeOption.name)
        this.$set(this.payload, '_paymentSelectedByBuyer', false)
        return
      }
    },
    listenScreenMoreThan991px() {
      this.mediaQueryMoreThan991px = window.matchMedia("(min-width: 991px)");
      this.screenMoreThan991px = this.mediaQueryMoreThan991px.matches
      this.mediaQueryMoreThan991px.addEventListener("change", (e) => {
        this.screenMoreThan991px = e.matches
      });
    }
  },
  mounted() {
    if(this.data.multiplyVariations && !this.data.cartOrder){
      this.data.variablePrices=this.data.variablePrices.filter(x=>!x.delete);
    }

    for (let i = 1; i <= 100; i++) {
      this.quantityOptions.push(i.toString());
    }
    this.getSelectedVariantImage();
    this.updateQuantity();
    this.calcCart();
    this.deliveryCourierPrice =
      this.payload.deliveryCourier + "==" + this.payload.deliveryPrice;
    this.checkShowPaymentHideView();
    this.autoSelectPayment();
    // if(this.data.saveInfoWithoutEnable && this.data.isSaveInfoNextTime){
    //  this.saveDataForNexttime()
    // }

    if (this.isMobile && this.$refs['rightContainer'] && (this.$refs['rightContainer'].childElementCount || 0) <= 0) {
      this.$refs['rightContainer'].style.marginTop = '0 !important';
    }

    this.listenScreenMoreThan991px();
  },
  watch: {
    "payload.deliveryCourier": {
      async handler(val) {
        try {
          const estimateDelivery = this.loadEstimateDelivery(val);
          if (estimateDelivery.unsupported) {
            this.isAddressUnsupported = true;
            this.isAddressUnsupportedCod = true;
          } else if (estimateDelivery.unsupportedCod) {
            this.isAddressUnsupported = false;
            this.isAddressUnsupportedCod = true;
          } else {
            this.isAddressUnsupported = false;
            this.isAddressUnsupportedCod = false;
          }
        } catch (error) {
          console.log("error", error);
        }
      },
      deep: true,
    },
    'payload.address': {
      async handler(val) {
        this.estimate()
        this.checkAvailablePaymentMethod(val)
      },
      deep: true,
    },
    cartSummary: {
      handler() {
        this.calcCart();
      },
      deep: true,
    },
    selectedbumpArray: {
      handler() {
        this.calcCart();
      },
      deep: true,
    },
    payload: {
      handler() {
        this.$emit("updateCheckout");
      },
      deep: true,
    },
    "data.requestedFields": {
      handler() {
        this.$emit("updateCheckout");
        // this.validate();
        // this.$emit("onValidate", true);
      },
      deep: true,
    },
    deliveryCourierPrice: {
      handler() {
        this.$emit("onValidate", true);
      },
      deep: true,
    },
    courierOptionDataFinal: {
      handler(val) {
        if(val && val.length>0){
          this.deliveryCourierPrice = val[0].value;
          this.id = new Date().getTime();
          setTimeout(() => {
            this.changeCouriePrice();
            this.$forceUpdate();
          }, 1000);
       }
      },
      deep: true,
    },
    "payload.variablePrices": {
      handler() {
        this.getSelectedVariantImage();
        if (this.data.addQuantity) {
          this.updateQuantity();
        }
      },
      deep: true,
    },
    // "payload.discount.code": {
    //   handler(val) {
    //     if(val==''){
    //       this.clearDiscountCode()
    //     }       
    //   },
    //   deep: true,
    // },
    delivery: {
      handler() {
        this.deliveryCourierPrice =
          this.payload.deliveryCourier + "==" + this.payload.deliveryPrice;
      },
      deep: true,
    },
    quantity: {
      handler: debounce(function (val) {
        let keys = Object.keys(this.payload.variablePrices);
        let dataVal = this.payload.variablePrices
          ? keys.map((o) => this.payload.variablePrices[o].name).join(" / ")
          : undefined;
        let ftr = this.data.variablePrices.filter(
          (attr) => attr.name == dataVal
        );
        if (ftr && ftr.length) {
          ftr[0].qty = val;
        }
        this.$forceUpdate();
      }, 500),
      deep: true,
    },
    "payload.payment": {
      handler(val) {
        this.calcCart();
        this.paymentFeeMethodName(val);
      },
      deep: true,
    },
    "payload.deliveryPrice": {
      handler() {
        this.calcCart();
      },
      deep: true,
    },
    "payload.bump": {
      handler() {
        this.calcCart();
      },
      deep: true,
    },
    errors: {
      handler(errors) {
        // validate quantity
        if (errors['zeroQTY'] && this.$refs['zeroQTY']) {
          this.$refs['zeroQTY'].scrollIntoView({ behavior: 'smooth' })
          return
        }
        // validate deliveryCourierPrice
        if (errors['deliveryCourierPrice'] && this.$refs['deliveryCourierPrice']) {
          this.$refs['deliveryCourierPrice'].scrollIntoView({ behavior: 'smooth' })
          return
        }
        const isPreviousError = Boolean(errors['zeroQTY']) || Boolean(errors['deliveryCourierPrice'])
        // update dynamic input
        for (let i = 0; i < this.data.requestedFields.length; i++) {
          const field = this.data.requestedFields[i].field
          if (!isPreviousError && errors[field] && this.$refs[field]) {
            const element = this.$refs[field][0]
            element && element.scrollIntoView({ behavior: 'smooth' });
            break;
          }
        }
      },
      deep: true,
    },
    availablePaymentMethod: {
      handler() {
        this.autoSelectPayment();
      },
    },
    "data.paymentType": {
      handler() {
        this.autoSelectPayment();
      },
      deep: true,
    },
    "data.epaymentSettings": {
      handler() {
        this.autoSelectPayment();
      },
      deep: true,
    },
  },
  filters: {
    g_number_format(val) {
      return new Intl.NumberFormat().format(val);
    },
    gramsToKilograms_format(val) {
      return (val / 1000).toFixed(1);
    },
  },
};
</script>

<style lang="scss">
.vs-form-control.phone-input input[type=number]::-webkit-inner-spin-button, 
.vs-form-control.phone-input input[type=number]::-webkit-outer-spin-button { 
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  margin: 0; 
}
.recipient__form__field {
  textarea {
    font-size: 14px;
  }
  // for date picker
  .mx-input {
    font-size: 14px;
    border-radius: 8px;
    border-color: #BFCEE0;
    &::placeholder {
      color: #6C7E95;
    }
    &:hover {
      border-color: #BFCEE0;
    }
  }
  .vs-select__label {
    opacity: 1 !important;
  }
  .select-value-label {
    opacity: 1 !important;
    color: #203551;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 15px;
    letter-spacing: 0.3px;
    &.placeholder-text {
      color: #6C7E95;
    }
  }
  .vs-select__input:focus {
    border: 2px solid #2e47ba !important;
  }
}
.cheapest-label{
  padding: 0px 6px;
  color: #FFFFFF;
  border-radius: 4px;
  background: linear-gradient(98.41deg, #E80B0B 22.37%, #DC4F00 68.66%);
  font-size: 11px;
  font-weight: 500;
  height: 14px;
  display: flex;
  line-height: 14px;
  margin-top: 1px;
}
.embed-payment-method {
  .disabled,
  [disabled] {
    opacity: 1 !important;

    .vs-radio__effect {
      &::after {
        border-color: #D5DAF1 !important;
      }
    }
  }
}
.vs-form-control.phone-input input[type=number]::-webkit-inner-spin-button, 
.vs-form-control.phone-input input[type=number]::-webkit-outer-spin-button { 
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  margin: 0; 
}
.select-coupon {
  width: 100%;
  input[type=radio] {
    flex-shrink: 0;
    margin-right: 15px;

    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    background-color: #fff;
    margin: 0;
    font: inherit;
    color: currentColor;
    width: 18px;
    height: 18px;
    border: 0.15em solid #BCCADC;
    border-radius: 50%;

    transition: border 50ms ease-out;
    align-self: center;
    display: grid;
    place-content: center;
    cursor: pointer;

    &:checked {
      border: 0.35em solid #2E47BA;
    }

    &:disabled {
      cursor: pointer;
      opacity: 0.6;

      &:not(:checked) {
        opacity: 0.4;
      }
    }
  }
}
.buy-button {
  &[data-size=Small],
  &[data-size=Medium] {
    min-height: 46px !important;
  }
  &[data-size=Large] {
    min-height: 50px !important;
  }
  &[data-size=Extra-Large] {
    min-height: 56px !important;
  }
}
.e-payment-admin-fee {
  font-size: 11px;
  font-weight: 500;
  color: #6C7E95;
  margin-top: 2px !important;
}
.single-variant {
  overflow-wrap: anywhere;
  &>:not([hidden])~:not([hidden]) {
    margin-top: 3px !important;
    margin-bottom: 0px !important;
  }
}
.addressText-textarea {
  border: 1px solid #bfcee0;
  border-radius: 8px !important;
  font-size: 13px;
  line-height: 18px;
  letter-spacing: 0.02em;
  background-color: #fff !important;
  padding: 7px 13px;
  width:100%;
}

.addressText-textarea::placeholder {
  color: #6C7E95;
  opacity: 1;
}

.focus-active-field .addressText-textarea:focus {
  outline: 1px solid #2E47BA !important;
  // border: 2px solid #2E47BA !important;
}
.courierOptionsWithPrice {
  justify-content: space-between;
  align-items: center;
  h6.types-ofcourier {
    font-weight: 500;
    font-size: 12px;
    line-height: 18px;
    letter-spacing: 0.02em;
    text-align: left;
    &[data-disabled=true] {
      color: #BFCEE0 !important;
    }
  }
  p.shipping-address {
    font-weight: 400;
    font-size: 12px;
    line-height: 18px;
    letter-spacing: 0.02em;
    text-align: left;
  }
  h6.shipping-price {
    font-weight: 600;
    font-size: 12px;
    line-height: 18px;
    letter-spacing: 0.02em;
    text-align: left;
  }
}
.embed-paymentType,
.courierOptionsWithPrice {
  .unsupported-badge {
    display: flex;
    align-items: center;
    gap: 2px;
    height: 22px;
    padding: 4px 6px;
    font-size: 11px;
    font-weight: 500;
    color: #E12121;
    background-color: #FFE3E3;
    border-radius: 4px;
  }
}
.dropdown-options-shipping {
  padding: 0 !important;

  & > ul {
    display: flex;
    flex-direction: column;
    gap: 6px;
  }

  .classic-form__dropdown__options__item {
    border-radius: 0 !important;
  }
}
</style>

<style scoped>
.pre-order {
  background-color: #EEF1FF;
  gap: 10px;
  padding: 8px 15px;
  border: 1px solid #2E47BA;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 500;
  margin-bottom: 10px;
}
.OtherContent_wrapper {
  background: #eef0fa;
  padding: 10px 15px;
}
.flat-and-free .attributes {
  background-color: #fff !important;
  padding: 11px 15px !important;
}
.flat-free-title {
  color: #203551;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 20px;
  letter-spacing: 0.28px;
  text-transform: capitalize;
}
.shippingType-title {
  border-radius: 4px;
  background: #e0e3ea;
  display: flex;
  padding: 0px 8px;
  align-items: center;
  gap: 10px;
  color: #62738a;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  line-height: 20px;
  letter-spacing: 0.48px;
  text-transform: capitalize;
}
.free-shippingType-title {
  border-radius: 4px;
  background: #04ac0d;
  color: #fff;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  line-height: 20px;
  letter-spacing: 0.48px;
  text-transform: capitalize;
  display: flex;
  padding: 0px 8px;
  align-items: center;
  gap: 5px;
}
.radio-form {
  padding: 8px 15px;
  border: 1px solid #bfcee0 !important;
  border-radius: 8px;
}

.options-wrap {
  background: #ffffff;
  border: 1px solid #bfcee0;
  border-radius: 8px;
  align-items: center;
}

.increDecre-btn-wrap {
  background-color: #F6F8FC;
  border: 1px solid #E0E9F4;
  border-radius: 0px 8px 8px 0px;
  padding: 6px;
  height: 44px;
  align-items: center;
  font-size: 14px;
}

/* ZERO REFERENCE MAYBE NEED TO CHECK IF NOT USE DELETE IT*/
/* Embed-Popup */
@media (max-width: 575px) {
  .container-fluid {
    padding: 0px !important;
  }
}

.bump-image img {
  border-radius: 8px;
}

.options-wrap .qty-input {
  opacity: 1;
}

.embed-rightGroup {
  margin-top: 10px !important;
}

.after_bg_payment {
  position: relative;
  padding: 15px 0px !important;
  z-index: 0;
}
.after_bg_payment::after {
  content: "";
  /* background: #eef0fa; */
  width: 111%;
  height: 100%;
  position: absolute;
  left: -20px;
  right: -20px;
  top: 0;
  z-index: -1;
}

.bump-data-text {
  max-width: 400px;
  width: 100%;
  word-wrap: break-word;
}

.save-nextTime {
  width: 20px;
  margin-right: 10px;
}

.product-options {
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  letter-spacing: 0.02em;
  color: #203551;
}
</style>

<style>
.OtherContent_wrapper p {
  margin:0 !important;
}
.qty-input.no-bg input {
  font-weight: 500;
  letter-spacing: 0.02em;
  color: #203551;
  text-align: center;
  background: transparent !important;
  border: none !important;
}

.minus-btn .bg-pm-btn,
.plus-btn .bg-pm-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  background: #ffffff;
  border: 2px solid #E0E9F4;
  border-radius: 8px;
  height: 32px;
  width: 32px;
}

.bg-pm-btn .horizontal {
  height: 1.3px;
  width: calc(100% - 20px);
  background: #6c7e95;
  margin: 14px auto;
  border-radius: 1px;
}

.bg-pm-btn .vertical {
  width: 1.3px;
  height: calc(100% - 20px);
  border-radius: 1px;
  background: #6c7e95;
  position: absolute;
  top: 10px;
  left: 14px;
}

.total-variant-info {
  background: #ffffff;
  border: 1px solid #bfcee0;
  border-radius: 8px;
  padding: 10px;
}

.m_float_btn {
  position: fixed;
  width: 60px;
  height: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
  right: 20px;
  bottom: 20px;
  z-index: 9999;
  border-radius: 100% !important;
  min-width: 60px;
  min-height: 60px !important;
}

.bump {
  border-radius: 15px;
  padding: 15px;
  border: 1.5px dashed #f09126;
}

.save-information label.vs-checkbox-label {
  justify-content: left !important;
}
</style>
<style lang="scss">
@import "@/assets/styles/pages/checkout/components/form/right.scss";
</style>
